import React, { useState, useEffect } from "react";
import {
  Form,
  Modal,
  Row,
  Col,
  Container,
  Button,
} from "react-bootstrap";
import SunEditor from "suneditor-react";
import AuthApi from "../../../api/authApi";
import RetreatApi from "../../../api/retreatApi";
import { toast } from "react-toastify";
import DatePicker from "../../../components/AppDatePicker";
import TimePicker from "../../../components/TimePicker";
import moment from "moment-timezone";
import {
  getRetreatImagePreviewSrc,
  processRetreatImage,
  RETREAT_IMAGE_ACCEPT,
} from "../../../utils/processRetreatImage";
import AlertModal from "../../../components/AlertModel";
import uploadRetreat from "../../../assets/images/uploadRetreat.png";
import corruptedImg from "../../../assets/images/corrupted-img.png";
import Select from "react-select";
import AdminApi from "../../../api/admin";
import PriestApi from "../../../api/priestApi";
import RolesApi from "../../../api/RolesApi";
import RetreatRoasterApi from "../../../api/retreatRoasterApi";
import { Cookies } from "react-cookie";
import { Link, useNavigate, useParams } from "react-router-dom";
import DeleteModel from "../../../components/DeleteModel";
import ViewMailMsg from "../../../components/ViewMailMsg";
import { useTranslation } from "react-i18next";
import { formatParishOptionLabel } from "../../../utils/parishLabels";
import { formatCoupleOptionLabel } from "../../../utils/coupleLabels";
import CreateRetreatSubAdmin from "../../../components/createRetreatSubAdmin";
import AlertDelete from "../../../components/AlertDelete";
import DescriptionSampleTip from "../../../components/DescriptionSampleTip";
import CreateRetreatTeam from "../../../components/createRetreatTeam";
import CopyableInput from "../../../components/CopyableInput";
import RetreatFormModal from "../../../components/RetreatFormModal";
import { renderRetreatDateHeader } from "../../../components/retreatDateHeader";
import RetreatImageUploadInfo from "../../../components/RetreatImageUploadInfo";
import RetreatPublicView from "../../../components/RetreatPublicView";
import "../../../assets/css/RegistrationRetreatModern.css";
import "../../../assets/css/CreateRetreatModern.css";
import { useTrainingGuide } from "../../../components/AdminTrainingGuide";
import SampleContentApi from "../../../api/SampleContentApi";

export const CreateRetreat = () => {
  const [data, setData] = useState({
    id: "",
    retreatment: "",
    title: "",
    parish: "",
    language: "",
    location: "",
    schedule: [],
    image1: "",
    image2: "",
    heading: "",
    mission_statement: `"The mission of the LOVESTRONG Marriage Ministry is to support, strengthen, and nurture the Christ-centered marital bond between a man and a woman utilizing an experiential-based weekend retreat program."`,
    description: "",
    mail_msg: "",
    paymentLink: "",
    priestId: "",
  });

  const [timeDate, setTimeDate] = useState({
    date: new Date(),
    from: "00 : 00",
    to: "00 : 00",
  });

  const [newTitle, setNewTitle] = useState({
    parish: "",
    language: "",
    location: "",
  });

  const { t, i18n } = useTranslation();

  const [validated, setValidated] = useState(false);
  const [perishDataList, setPerishDataList] = useState([]);
  const [editIndex, setEditIndex] = useState(null);
  const [isTempUpload1, setIsTempUpload1] = useState(false);
  const [isTempUpload2, setIsTempUpload2] = useState(false);
  const [isTempUpload, setIsTempUpload] = useState(false);
  const [applyLoader, setApplyLoader] = useState(false);
  const [ediUserIdClicked, setEdiUserIdClicked] = useState("");
  const [oldData, setOldData] = useState([]);
  const [oldValues, setOldValues] = useState([]);
  const [removeAccessModal, setRemoveAccessModal] = useState(false);
  const [Pass, setPass] = useState(false);
  const [show, setShow] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [rolesDataList, setRolesDataList] = useState([]);
  const [roleSelect, setRoleSelect] = useState([]);
  const [allCoupleData, setAllCoupleData] = useState([]);
  const [coupleSelectForRole, setCoupleSelectForRole] = useState([]);
  const [roleGreenTick, setRoleGreenTick] = useState(false);
  const [roles, setRoles] = useState([]);
  const [description, setDescription] = useState("");
  const [emailMsg, setEmailMsg] = useState("");
  const [leadCoupleLoader, setLeadCoupleLoader] = useState(false);
  const [coLeadCoupleLoader, setCoLeadCoupleLoader] = useState(false);
  const [mentorLoader, setMentorLoader] = useState(false);
  const [spiritualDirectorLoader, setSpiritualDirectorLoader] = useState(false);
  const [shadowLeadCoupleLoader, setShadowLeadCoupleLoader] = useState(false);
  const [spiritualMentorLoader, setSpiritualMentorLoader] = useState(false);
  const [allCoupleMails, setAllCoupleMails] = useState([]);
  const [mailSample, setMailSample] = useState(false);
        const [descriptionSample, setDescriptionSample] = useState(false);
  
  const [removeCoupleModal, setRemoveCoupleModal] = useState("");
  const [missionStatement, setMissionStatement] = useState("");
  const [fromErrorMsg, setFromErrorMsg] = useState(false);
  const [toErrorMsg, setToErrorMsg] = useState(false);
  const [check, setCheck] = useState("");
  const [mailMsgView, setMailMsgView] = useState(false);
  const [dynamicDescription, setDynamicDescription] = useState("");
  const [dynamicEmailMsg, setDynamicEmailMsg] = useState("");
  const [createRetAdmin, setCreateRetAdmin] = useState(false);
  const [isDisabledShow, setIsDisabledShow] = useState(false);
  const [createRetTeam, setCreateRetTeam] = useState(false);
  const [priestsList, setPriestsList] = useState([]);

  const [coupleForRoleToRemove, setCoupleForRoleToRemove] = useState(false);
  const [showFullEditModal, setShowFullEditModal] = useState(false);
  const [openSections, setOpenSections] = useState({
    parish: true,
    weekend: false,
    story: false,
    payment: false,
    team: false,
  });
  const training = useTrainingGuide();
  const trainingStep = training?.isOpen
    ? training.guide?.steps[training.stepIndex]
    : null;
  const trainingSection = trainingStep?.section || "";
  const trainingStepKey = training?.isOpen
    ? `${training.guideId}:${training.stepIndex}:${trainingSection}`
    : "";
  useEffect(() => {
    if (!trainingSection) return undefined;
    if (trainingSection !== "save") {
      setOpenSections((prev) =>
        prev[trainingSection] ? prev : { ...prev, [trainingSection]: true },
      );
    }
    const timer = window.setTimeout(() => {
      document
        .querySelector(`[data-cr-section="${trainingSection}"]`)
        ?.scrollIntoView({ behavior: "smooth", block: "start" });
    }, 80);
    return () => window.clearTimeout(timer);
  }, [trainingStepKey, trainingSection]);
  const [fullCouples, setFullCouples] = useState([]);
  const [coupleSelectForAccess, setCoupleSelectForAccess] = useState([]);
  const [accessGreenTick, setAccessGreenTick] = useState(false);
  const [selectedPriestOption, setSelectedPriestOption] = useState(null);
  const [selectedCoupleOptions, setSelectedCoupleOptions] = useState({
    lead_couple: null,
    co_lead_couple: null,
    mentor_couple: null,
    spiritual_mentor_couple: null,
  });

  let cookies = new Cookies();
  let userData = cookies.get("LoveStrongUser") || null;
  let authApi = new AuthApi();
  let retreatApi = new RetreatApi();
  let priestApi = new PriestApi();
  let adminApi = new AdminApi();
  let rolesApi = new RolesApi();
  let retreatRoasterApi = new RetreatRoasterApi();
  let sampleContentApi = new SampleContentApi();
  const { id } = useParams();
  let navigate = useNavigate();

  const loadDescriptionAndEmailSamples = (lang) => {
    const selectedLang = lang || "english";
    sampleContentApi
      .getSampleContent("Retreat Description", selectedLang)
      .then((res) => {
        if (res.success && res.data) setDynamicDescription(res.data.content);
        else setDynamicDescription("");
      });
    sampleContentApi
      .getSampleContent("Retreat Email Message", selectedLang)
      .then((res) => {
        if (res.success && res.data) setDynamicEmailMsg(res.data.content);
        else setDynamicEmailMsg("");
      });
  };

  useEffect(() => {
    if (!id) {
      getMissionStatement();
    }
    getPerishList();
    getrolesList();
    getAllCouples();
    getPriestsList();
  }, []);

  const getPriestsList = async () => {
    try {
      let d = {};
      d.pageNo = 1;
      d.size = 20;
      d.export = true;
      const res = await priestApi.getAllPriests(d);
      if (res.success && res.data) setPriestsList(res.data);
    } catch (e) {
      console.error(e);
    }
  };

  useEffect(() => {
    if (id) {
      editRetreat(id);
      getRolesOfRetreats(id);
    }
  }, [id]);

  useEffect(() => {
    loadDescriptionAndEmailSamples(data?.language);
    if (data?.language) {
      sampleContentApi
        .getSampleContent("Mission Statement", data.language)
        .then((res) => {
          if (res.success && res.data) setMissionStatement(res.data.content);
        });
    }
  }, [data?.language]);

  const formattedDate = (date) => {
    return moment(date).tz("America/New_York").format("YYYY-MM-DD");
  };

  function formatLabel(firstName, lastName, email) {
    let namePart = "";
    if (lastName) {
      namePart += lastName;
    }

    if (firstName) {
      namePart += (lastName ? ", " : "") + firstName;
    }

    return namePart ? `${namePart} - ${email}` : email;
  }

  const getAllCouples = async () => {
    await adminApi
      .allCouples()
      .then(async (res) => {
        if (res.success) {
          setFullCouples(res.data);
          let allcoupleList = [];

          let allMailcoupleList = [];
          res.data &&
            res.data.forEach((item) => {
              if (item.hisFirstName || item.hisLastName || item.herFirstName) {
                const emails = [item.hisEmail, item.herEmail]
                  .filter(Boolean)
                  .join(" & ");

                allcoupleList.push({
                  label: formatCoupleOptionLabel(item),
                  value: item.id,
                });
              }

              if (item.hisEmail) {
                allMailcoupleList.push({
                  label: formatLabel(
                    item.hisFirstName,
                    item.hisLastName,
                    item.hisEmail,
                  ),
                  value: item.id,
                });
              }

              if (item.herEmail) {
                allMailcoupleList.push({
                  label: formatLabel(
                    item.herFirstName,
                    item.herLastName,
                    item.herEmail,
                  ),
                  value: item.id,
                });
              }
            });

          const sort = allcoupleList.sort((a, b) =>
            a.label.localeCompare(b.label),
          );
          setAllCoupleData(sort);
          await adminApi.outerUsers().then((res) => {
            if (res.success) {
              res.data &&
                res.data.forEach((item) => {
                  if (item.email) {
                    allMailcoupleList.push({
                      label: item.email,
                      value: item.id,
                    });
                  }
                });
              setAllCoupleMails(allMailcoupleList);
            }
          });
        } else {
          toast.error(res.msg);
        }
      })
      .catch((error) => {
        toast.error(error);
      });
  };

  const getrolesList = async () => {
    await rolesApi
      .getAllRoleList()
      .then(async (res) => {
        let roles = [];
        res.data &&
          res.data.forEach((item) => {
            if (item.role) {
              roles.push({
                label: item.role,
                value: item.id,
              });
            }
          });
        const filteredRoles = roles.filter(
          (role) =>
            role.label === "Lead" ||
            role.label === "Co-Lead" ||
            // role.label === "Shadow Lead" ||
            role.label === "Spiritual Director" ||
            role.label === "Spiritual Mentor" ||
            role.label === "Mentor",
        );

        const roleOrder = [
          "Lead",
          "Co-Lead",
          // "Shadow Lead",
          "Mentor",
          "Spiritual Mentor",
          "Spiritual Director",
        ];

        const sortedRoles = filteredRoles.sort(
          (a, b) => roleOrder.indexOf(a.label) - roleOrder.indexOf(b.label),
        );
        setRolesDataList(sortedRoles);
      })
      .catch((error) => {
        toast.error(error.toString());
      });
  };

  const getRolesOfRetreats = async (id) => {
    await authApi.getRolesOfRetreats({ id: id }).then(async (response) => {
      setRoles(response.data);
    });
  };

  const refreshRetreatAdmins = async (retreatId) => {
    const idToLoad = retreatId || ediUserIdClicked;
    if (!idToLoad) return;
    try {
      const res = await retreatApi.getRetreatDetail({ id: idToLoad });
      if (res?.success && res.data?.[0]) {
        setData((prev) => ({
          ...prev,
          userEmails: res.data[0].userEmails || [],
        }));
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    const sd = roles?.spiritualDirector;
    if (sd?.priestId && priestsList?.length) {
      const priest = priestsList.find((p) => p.id === sd.priestId);
      if (priest) {
        setSelectedPriestOption({
          label: `${priest.title ? priest.title + " " : ""}${priest.firstName} ${
            priest.lastName || priest.name
          } - ${priest.email}`,
          value: priest.id,
        });
      } else {
        const firstName = sd.hisFirstName || sd.priestFirstName || "";
        const lastName = sd.hisLastName || sd.priestLastName || "";
        const email = sd.hisEmail || sd.priestEmail || "";
        setSelectedPriestOption({
          label: email
            ? `${firstName} ${lastName} - ${email}`.trim()
            : `${firstName} ${lastName}`.trim(),
          value: sd.priestId,
        });
      }
    } else if (!sd?.priestId) {
      setSelectedPriestOption(null);
    }
  }, [roles?.spiritualDirector, priestsList]);

  useEffect(() => {
    if (!allCoupleData?.length) return;
    const mapping = [
      ["lead_couple", roles?.leadCouple],
      ["co_lead_couple", roles?.coLeadCouple],
      ["mentor_couple", roles?.mentor],
      ["spiritual_mentor_couple", roles?.spiritualMentor],
    ];
    setSelectedCoupleOptions((prev) => {
      const next = { ...prev };
      mapping.forEach(([role, couple]) => {
        if (couple?.coupleId) {
          const opt = allCoupleData.find((o) => o.value === couple.coupleId);
          if (opt) next[role] = opt;
        } else if (!couple) {
          next[role] = null;
        }
      });
      return next;
    });
  }, [roles, allCoupleData]);

  const getSpiritualDirectorValue = (field) => {
    const sd = roles?.spiritualDirector;
    if (!sd) return "";
    switch (field) {
      case "firstName":
        return sd.firstName || sd.hisFirstName || sd.priestFirstName || "";
      case "lastName":
        return sd.lastName || sd.hisLastName || sd.priestLastName || "";
      case "email":
        return sd.email || sd.hisEmail || sd.priestEmail || "";
      default:
        return "";
    }
  };

  const getMissionStatement = async () => {
    await authApi
      .getMissionStatement()
      .then((response) => {
        if (response && response.data && response.data.mission_statement) {
          setMissionStatement(response.data.mission_statement);
        } else {
          setMissionStatement(
            `<p><em>"The mission of the LOVESTRONG Marriage Ministry is to support, strengthen, and nurture the Christ-centered marital bond between a man and a woman utilizing an experiential-based weekend retreat program."</em></p>`,
          );
        }
      })
      .catch((error) => {
        toast.error(error.toString());
      });
  };

  const getPerishList = async () => {
    await authApi
      .getPerishList()
      .then((response) => {
        const sortedList = response.data.sort((a, b) =>
          a.parish.localeCompare(b.parish),
        );
        setPerishDataList(sortedList);
      })
      .catch((error) => {
        toast.error(error.toString());
      });
  };

  const handleChanges = (name, e) => {
    let d = { ...data };
    let s = { ...newTitle };
    let o = { ...oldData };
    if (e.target.name == "title" && name == "") {
      o.title = oldValues.title;
    } else if (e.target.name == "parish" && name == "") {
      o.parish = oldValues.parish;
    } else if (e.target.name == "language" && name == "") {
      o.language = oldValues.language;
    } else if (e.target.name == "location" && name == "") {
      o.location = oldValues.location;
    } else if (e.target.name == "image1" && name == "") {
      o.image1 = oldValues.image1;
    } else if (e.target.name == "image2" && name == "") {
      o.image2 = oldValues.image2;
    } else if (e.target.name == "heading" && name == "") {
      o.heading = oldValues.heading;
    } else if (e.target.name == "mission_statement" && name == "") {
      o.mission_statement = oldValues.mission_statement;
    } else if (e.target.name == "description" && name == "") {
      o.description = oldValues.description;
    }
    setOldData(o);
    if (!name) {
      d[e.target.name] = e.target.value;
    }
    if (e.target.name === "parish") {
      let getPerish = perishDataList.find((m) => m.id == e.target.value);
      if (getPerish) {
        s["parish"] = getPerish.parish;
        setNewTitle(s);
        if (getPerish.address) {
          d.location = getPerish.address;
        }
        if (newTitle.language != "" && newTitle.location == "") {
          d.title =
            getPerish.parish +
            " (" +
            newTitle.language.charAt(0).toUpperCase() +
            newTitle.language.slice(1) +
            ") ";
        } else if (newTitle.language == "" && newTitle.location != "") {
          d.title = getPerish.parish + ", " + newTitle.location;
        } else if (newTitle.language != "" && newTitle.location != "") {
          d.title =
            getPerish.parish +
            " (" +
            newTitle.language.charAt(0).toUpperCase() +
            newTitle.language.slice(1) +
            ") " +
            newTitle.location;
        } else {
          d.title = getPerish.parish || "";
        }
        d.myparish = getPerish;
      } else {
        const previousParish = perishDataList.find((m) => m.id == data.parish);
        s.parish = "";
        if (previousParish?.address && d.location === previousParish.address) {
          d.location = "";
          s.location = "";
        }
        setNewTitle(s);
        const language = newTitle.language || "";
        const location = s.location || "";
        if (language && !location) {
          d.title = language.charAt(0).toUpperCase() + language.slice(1);
        } else if (!language && location) {
          d.title = location;
        } else if (language && location) {
          d.title =
            language.charAt(0).toUpperCase() +
            language.slice(1) +
            ", " +
            location;
        } else {
          d.title = "";
        }
        d.myparish = null;
      }
      if (d.language && d.location && d.schedule.length) {
        autoSaveFunction(d);
      }
      if (
        d &&
        d.schedule &&
        (!d.schedule[0] ||
          !d.schedule[0].from ||
          d.schedule[0].from === "00 : 00")
      ) {
        setFromErrorMsg(true);
      }
      if (
        d &&
        d.schedule &&
        (!d.schedule[0] || !d.schedule[0].to || d.schedule[0].to === "00 : 00")
      ) {
        setToErrorMsg(true);
      }
      setValidated(true);
    }
    if (e.target.name === "language") {
      s["language"] = e.target.value;
      const selectedLang = e.target.value;
      sampleContentApi.getSampleContent("Mission Statement", selectedLang).then(res => {
        if (res.success && res.data) {
          setMissionStatement(res.data.content);
          d.mission_statement = res.data.content.replace(/<[^>]*>/g, '');
        } else {
          if (selectedLang === "spanish") {
            d.mission_statement = `"La misión de la Iglesia de Santa Monica y la del Ministerio de Matrimonios LOVESTRONG es el de apoyar, fortalecer y alimentar la unión centrada en Cristo, entre parejas casadas de nuestra Iglesia y Comunidad."`;
            setMissionStatement(`<p><em>"La misión de la Iglesia de Santa Monica y la del Ministerio de Matrimonios LOVESTRONG es el de apoyar, fortalecer y alimentar la unión centrada en Cristo, entre parejas casadas de nuestra Iglesia y Comunidad."</em></p>`);
          } else {
            d.mission_statement = `"The mission of the LOVESTRONG Marriage Ministry is to support, strengthen, and nurture the Christ-centered marital bond between a man and a woman utilizing an experiential-based weekend retreat program."`;
            setMissionStatement(`<p><em>"The mission of the LOVESTRONG Marriage Ministry is to support, strengthen, and nurture the Christ-centered marital bond between a man and a woman utilizing an experiential-based weekend retreat program."</em></p>`);
          }
        }
        setData({ ...d });
      });

      loadDescriptionAndEmailSamples(selectedLang);

      i18n.changeLanguage(selectedLang);
      setNewTitle(s);
      if (newTitle.parish != "" && newTitle.location == "") {
        d.title =
          newTitle.parish +
          " (" +
          e.target.value.charAt(0).toUpperCase() +
          e.target.value.slice(1) +
          ") ";
      } else if (newTitle.parish == "" && newTitle.location != "") {
        d.title =
          e.target.value.charAt(0).toUpperCase() +
          e.target.value.slice(1) +
          ", " +
          newTitle.location;
      } else if (newTitle.parish != "" && newTitle.location != "") {
        d.title =
          newTitle.parish +
          " (" +
          e.target.value.charAt(0).toUpperCase() +
          e.target.value.slice(1) +
          ") " +
          newTitle.location;
      } else {
        d.title =
          e.target.value.charAt(0).toUpperCase() + e.target.value.slice(1);
      }
      if (!e.target.value) {
        d.title = d.title.substring(0, d.title.length - 2);
      }
      if ((d.parishId || d.parish) && d.location && d.schedule.length) {
        autoSaveFunction(d, d.mission_statement);
      }
      if (
        d &&
        d.schedule &&
        (!d.schedule[0] ||
          !d.schedule[0].from ||
          d.schedule[0].from === "00 : 00")
      ) {
        setFromErrorMsg(true);
      }
      if (
        d &&
        d.schedule &&
        (!d.schedule[0] || !d.schedule[0].to || d.schedule[0].to === "00 : 00")
      ) {
        setToErrorMsg(true);
      }
      setValidated(true);
    }
    if (e.target.name === "location") {
      s["location"] = e.target.value;
      setNewTitle(s);
      if (newTitle.parish != "" && newTitle.language == "") {
        d.title = newTitle.parish + ", " + e.target.value;
      } else if (newTitle.parish == "" && newTitle.language != "") {
        d.title =
          newTitle.language.charAt(0).toUpperCase() +
          newTitle.language.slice(1) +
          ") " +
          e.target.value;
      } else if (newTitle.parish != "" && newTitle.language != "") {
        d.title =
          newTitle.parish +
          " (" +
          newTitle.language.charAt(0).toUpperCase() +
          newTitle.language.slice(1) +
          ") " +
          e.target.value;
      } else {
        d.title = e.target.value;
      }
      if (!e.target.value) {
        d.title = d.title.substring(0, d.title.length - 2);
      }
      // if (d.parish && d.language) {
      //   autoSaveFunction(d);
      // }
    }
    if (e.target.name == "image1") {
      const file = e.target.files[0];
      if (file) {
        processRetreatImage(file)
          .then((processedFile) => {
            d.image1 = processedFile;
            if (d.parishId && d.language && d.location && d.schedule.length) {
              autoSaveFunction(d);
            }
            if (
              d &&
              d.schedule &&
              (!d.schedule[0] ||
                !d.schedule[0].from ||
                d.schedule[0].from === "00 : 00")
            ) {
              setFromErrorMsg(true);
            }
            if (
              d &&
              d.schedule &&
              (!d.schedule[0] ||
                !d.schedule[0].to ||
                d.schedule[0].to === "00 : 00")
            ) {
              setToErrorMsg(true);
            }
            setValidated(true);
            setIsTempUpload1(true);
            setData({ ...d });
          })
          .catch((error) => {
            toast.error(error.message);
            e.target.value = "";
          });
      }
      return;
    }
    if (e.target.name == "image2") {
      d.image2 = e.target.files[0];
      if (d.parishId && d.language && d.location && d.schedule.length) {
        autoSaveFunction(d);
      }
      if (
        d &&
        d.schedule &&
        (!d.schedule[0] ||
          !d.schedule[0].from ||
          d.schedule[0].from === "00 : 00")
      ) {
        setFromErrorMsg(true);
      }
      if (
        d &&
        d.schedule &&
        (!d.schedule[0] || !d.schedule[0].to || d.schedule[0].to === "00 : 00")
      ) {
        setToErrorMsg(true);
      }
      setValidated(true);
    }
    setData(d);
  };

  const handleSubmitOnBlur = (e, selectEditor) => {
    const url = window.location.href;
    const parts = url.split("/");
    const lastPart = parts[parts.length - 1];
    let d = { ...data };
    if (selectEditor == "location") {
      if ((d.parish || d.parishId) && d.language && d.schedule.length) {
        let data = {
          selectEditor: selectEditor,
          id: lastPart,
          value: e.target.value,
          title: d.title,
        };
        retreatApi
          .autoSaveRetreat(data)
          .then((res) => {
            if (res.success) {
              toast.success(res.msg);
              clearfield();
              editRetreat(data.id);
              setApplyLoader(false);
            } else {
              toast.error(res.msg);
            }
          })
          .catch((error) => {
            toast.error(error);
          });
      } else {
        setValidated(true);
      }
    } else if (selectEditor == "heading") {
      if (
        (d.parish || d.parishId) &&
        d.language &&
        d.schedule.length &&
        d.location
      ) {
        let data = {
          selectEditor: selectEditor,
          id: lastPart,
          value: e.target.value,
        };
        retreatApi
          .autoSaveRetreat(data)
          .then((res) => {
            if (res.success) {
              toast.success(res.msg);
              clearfield();
              editRetreat(data.id);
              setApplyLoader(false);
            } else {
              toast.error(res.msg);
            }
          })
          .catch((error) => {
            toast.error(error);
          });
      } else {
        setValidated(true);
      }
    } else if (selectEditor == "paymentLink") {
      if (
        (d.parish || d.parishId) &&
        d.language &&
        d.schedule.length &&
        d.location
      ) {
        let data = {
          selectEditor: selectEditor,
          id: lastPart,
          value: e.target.value,
        };
        retreatApi
          .autoSaveRetreat(data)
          .then((res) => {
            if (res.success) {
              toast.success(res.msg);
              clearfield();
              editRetreat(data.id);
              setApplyLoader(false);
            } else {
              toast.error(res.msg);
            }
          })
          .catch((error) => {
            toast.error(error);
          });
      } else {
        setValidated(true);
      }
    } else if (selectEditor == "title") {
      if (
        (d.parish || d.parishId) &&
        d.language &&
        d.schedule.length &&
        d.location
      ) {
        let data = {
          selectEditor: selectEditor,
          id: lastPart,
          value: e.target.value,
        };
        retreatApi
          .autoSaveRetreat(data)
          .then((res) => {
            if (res.success) {
              toast.success(res.msg);
              clearfield();
              editRetreat(data.id);
              setApplyLoader(false);
            } else {
              toast.error(res.msg);
            }
          })
          .catch((error) => {
            toast.error(error);
          });
      } else {
        setValidated(true);
      }
    } else {
      if (lastPart === "create-retreat") {
        toast.error("Please enter the required fields.");
        setValidated(true);
      } else {
        let data = {
          selectEditor: selectEditor,
          id: lastPart,
          value: e.target.innerHTML,
        };
        retreatApi
          .autoSaveRetreat(data)
          .then((res) => {
            if (res.success) {
              toast.success(res.msg);
              clearfield();
              editRetreat(data.id);
              setApplyLoader(false);
            } else {
              toast.error(res.msg);
            }
          })
          .catch((error) => {
            toast.error(error);
          });
      }
    }
  };

  const handleSubmit = (e, { onSuccess } = {}) => {
    const form = e.currentTarget;
    e.preventDefault();
    e.stopPropagation();
    if (form.checkValidity()) {
      setIsTempUpload1(false);
      setIsTempUpload2(false);
      setApplyLoader(true);
      if (
        ediUserIdClicked &&
        ediUserIdClicked !== "" &&
        ediUserIdClicked !== null
      ) {
        let data1 = new FormData();
        if (data.image1 !== "") {
          data1.append("file1", data.image1);
        }
        if (data.image2 !== "") {
          data1.append("file2", data.image2);
        }
        let stateRef = { ...data };
        stateRef.mission_statement = missionStatement;
        stateRef.description = description;
        stateRef.mail_msg = emailMsg;
        // delete stateRef.imageUrl
        data1.append("fromData", JSON.stringify(stateRef));
        retreatApi
          .editRetreat(data1)
          .then((res) => {
            if (res.success) {
              toast.success(res.msg);
              clearfield();
              const { schedule, ...rest } = res.data;
              const parsedSchedule = schedule ? JSON.parse(schedule) : [];
              const parsedData = {
                ...rest,
                schedule: parsedSchedule.map((entry) => ({
                  date: new Date(entry.date),
                  from: entry.from,
                  to: entry.to,
                })),
              };
              let myparish = perishDataList.find(
                (i) => i.id === parsedData.parishId,
              );
              if (myparish) {
                parsedData.myparish = myparish;
              }
              parsedData.schedule.forEach((item) => {
                item.dayName = getDayName(item.date, parsedData.language);
              });
              setData(parsedData);
              onSuccess?.();



              let oldparish = perishDataList.find(
                (i) => i.id === oldData.parish,
              );
              let newparish = perishDataList.find(
                (i) => i.id === res.data.parishId,
              );









            } else {
              toast.error(res.msg);
              setApplyLoader(false);
            }
            setApplyLoader(false);
          })
          .catch((error) => {
            toast.error(error);
          });
      } else {
        let data1 = new FormData();
        data1.append("file1", data.image1);
        data1.append("file2", data.image2);
        let stateRef = { ...data };
        stateRef.mission_statement = missionStatement;
        stateRef.description = description;
        stateRef.mail_msg = emailMsg;
        delete stateRef.image1;
        delete stateRef.image2;
        data1.append("fromData", JSON.stringify(stateRef));
        retreatApi
          .createRetreat(data1)
          .then((res) => {
            if (res.success) {
              toast.success(res.msg);
              clearfield();
              onSuccess?.();
              // setShowREgModal(false);
              // editRetreat(res.data.id);
              navigate(`/create-retreat/${res.data.id}`);
              const { schedule, ...rest } = res.data;
              const parsedSchedule = schedule ? JSON.parse(schedule) : [];
              const parsedData = {
                ...rest,
                schedule: parsedSchedule.map((entry) => ({
                  date: new Date(entry.date),
                  from: entry.from,
                  to: entry.to,
                })),
              };
              let myparish = perishDataList.find(
                (i) => i.id === parsedData.parishId,
              );
              if (myparish) {
                parsedData.myparish = myparish;
              }
              setData(parsedData);

              setApplyLoader(false);
            } else {
              setApplyLoader(false);
              toast.error(res.msg);
            }
          })
          .catch((error) => {
            setApplyLoader(false);
            toast.error(error);
          });
      }
    } else {
      const invalidField = form.querySelector(":invalid");
      const invalidSection = invalidField
        ?.closest("[data-cr-section]")
        ?.getAttribute("data-cr-section");
      const weekendTimesMissing =
        data &&
        data.schedule &&
        (!data.schedule[0] ||
          !data.schedule[0].from ||
          data.schedule[0].from === "00 : 00" ||
          !data.schedule[0].to ||
          data.schedule[0].to === "00 : 00");
      if (invalidSection || weekendTimesMissing) {
        setOpenSections((prev) => ({
          ...prev,
          ...(invalidSection ? { [invalidSection]: true } : {}),
          ...(weekendTimesMissing ? { weekend: true } : {}),
        }));
      }
      if (
        data &&
        data.schedule &&
        (!data.schedule[0] ||
          !data.schedule[0].from ||
          data.schedule[0].from === "00 : 00")
      ) {
        setFromErrorMsg(true);
        setValidated(true);
      }
      if (
        data &&
        data.schedule &&
        (!data.schedule[0] ||
          !data.schedule[0].to ||
          data.schedule[0].to === "00 : 00")
      ) {
        setToErrorMsg(true);
      }
    }
    setValidated(true);
  };

  const clearfield = () => {
    setValidated(false);
  };

  function getDayName(dateString, language) {
    const dateInUSTimezone = moment(dateString).tz("America/New_York");
    let days = [];
    if (language === "spanish") {
      days = [
        "Domingo",
        "Lunes",
        "Martes",
        "Miércoles",
        "Jueves",
        "Viernes",
        "Sábado",
      ];
    } else {
      days = [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday",
      ];
    }
    return days[dateInUSTimezone.day()];
  }

  const autoSaveFunction = (newData, missionData) => {
    setIsTempUpload1(false);
    setIsTempUpload2(false);
    setApplyLoader(true);
    if (
      ediUserIdClicked &&
      ediUserIdClicked !== "" &&
      ediUserIdClicked !== null
    ) {
      let data1 = new FormData();
      if (newData.image1 !== "") {
        data1.append("file1", newData.image1);
      }
      if (newData.image2 !== "") {
        data1.append("file2", newData.image2);
      }
      let stateRef = { ...newData };
      stateRef.mission_statement =
        missionData !== "" ? missionData : missionStatement;
      stateRef.description = description;
      stateRef.mail_msg = emailMsg;
      // delete stateRef.imageUrl
      data1.append("fromData", JSON.stringify(stateRef));
      retreatApi
        .editRetreat(data1)
        .then((res) => {
          if (res.success) {
            toast.success(res.msg);
            clearfield();
            const { schedule, ...rest } = res.data;
            const parsedSchedule = schedule ? JSON.parse(schedule) : [];
            const parsedData = {
              ...rest,
              schedule: parsedSchedule.map((entry) => ({
                date: new Date(entry.date),
                from: entry.from,
                to: entry.to,
              })),
            };
            let myparish = perishDataList.find(
              (i) => i.id === parsedData.parishId,
            );
            if (myparish) {
              parsedData.myparish = myparish;
            }
            parsedData.schedule.forEach((item) => {
              item.dayName = getDayName(item.date, parsedData.language);
            });
            setData(parsedData);



            let oldparish = perishDataList.find((i) => i.id === oldData.parish);
            let newparish = perishDataList.find(
              (i) => i.id === res.data.parishId,
            );









          } else {
            setApplyLoader(false);
            toast.error(res.msg);
          }
          setApplyLoader(false);
        })
        .catch((error) => {
          setApplyLoader(false);
          toast.error(error);
        });
    } else {
      let data1 = new FormData();
      data1.append("file1", newData.image1);
      data1.append("file2", newData.image2);
      let stateRef = { ...newData };
      stateRef.mission_statement = missionStatement;
      stateRef.description = description;
      stateRef.mail_msg = emailMsg;
      delete stateRef.image1;
      delete stateRef.image2;
      data1.append("fromData", JSON.stringify(stateRef));
      retreatApi
        .createRetreat(data1)
        .then((res) => {
          if (res.success) {
            toast.success(res.msg);
            clearfield();
            // setShowREgModal(false);
            navigate(`/create-retreat/${res.data.id}`);
            const { schedule, ...rest } = res.data;
            const parsedSchedule = schedule ? JSON.parse(schedule) : [];
            const parsedData = {
              ...rest,
              schedule: parsedSchedule.map((entry) => ({
                date: new Date(entry.date),
                from: entry.from,
                to: entry.to,
              })),
            };
            setData(parsedData);

            setApplyLoader(false);
          } else {
            setApplyLoader(false);
            toast.error(res.msg);
          }
        })
        .catch((error) => {
          setApplyLoader(false);
          toast.error(error);
        });
    }
  };

  const upload = (selectUpload) => {
    if (selectUpload === "ForFirst") {
      document.getElementById("retreatImageUpload1").click();
    } else if (selectUpload === "ForFirstModal") {
      document.getElementById("retreatImageUpload1_modal").click();
    } else if (selectUpload === "ForSecond") {
      document.getElementById("retreatImageUpload2").click();
    } else {
      document
        .getElementById(`${selectUpload}` + "-" + "CoupleProfileUpload")
        .click();
      setIsTempUpload(true);
    }
  };

  const remove = (removeSelect) => {
    let d = { ...data };
    if (removeSelect === "ForFirst") {
      d.image1 = "";
      setIsTempUpload1(false);
      if (
        (d.parishId || d.parish) &&
        d.language &&
        d.location &&
        d.schedule.length
      ) {
        autoSaveFunction(d);
      }
    } else {
      d.image2 = "";
      setIsTempUpload2(false);
      if (
        (d.parishId || d.parish) &&
        d.language &&
        d.location &&
        d.schedule.length
      ) {
        autoSaveFunction(d);
      }
    }
    setData(d);
  };

  const deleteSchedule = () => {
    let d = { ...data };
    if (d.schedule.length > 0) {
      d.schedule.splice(editIndex, 1);
    }
    if (
      (d.parishId || d.parish) &&
      d.language &&
      d.location &&
      d.schedule.length
    ) {
      autoSaveFunction(d);
    }
    setShow(false);
  };

  const editRetreat = async (id) => {
    setEdiUserIdClicked(id);
    let d = { ...data };
    await retreatApi
      .getRetreatDetail({ id: id })
      .then((res) => {
        if (res.success) {
          const { schedule, ...rest } = res.data[0];
          const parsedSchedule = schedule ? JSON.parse(schedule) : [];
          let parsedData = {
            ...rest,
            schedule: parsedSchedule.map((entry) => ({
              date: new Date(entry.date),
              from: entry.from,
              to: entry.to,
            })),
            parish: res.data[0].parishId,
          };
          let myparish = perishDataList.find(
            (i) => i.id === parsedData.parishId,
          );
          if (myparish) {
            parsedData.myparish = myparish;
          }
          parsedData.schedule.forEach((item) => {
            item.dayName = getDayName(item.date, parsedData.language);
          });
          //Set Title data values
          let titleData = { ...newTitle };
          titleData.language = parsedData.language;
          titleData.location = parsedData.location;
          titleData.parish =
            parsedData.myparish && parsedData.myparish.parish
              ? parsedData.myparish.parish
              : "";
          setNewTitle(titleData); //
          i18n.changeLanguage(parsedData.language);
          setData(parsedData);
          setOldValues(parsedData);
          setEmailMsg(parsedData.mail_msg);
          setMissionStatement(parsedData.mission_statement);
          setDescription(parsedData.description);
        } else {
          toast.error(res.msg);
        }
      })
      .catch((error) => {
        toast.error(error);
      });
  };

  const showModal = (i) => {
    setEditIndex(i);
    setShowDeleteModal(true);
  };

  const handlerRemoveShow = (i) => {
    setEditIndex(i);
    setRemoveCoupleModal(true);
  };
  const handleRemoveClose = () => {
    setRemoveCoupleModal(false);
  };

  const handlerAccessRmvShow = (item) => {
    let isCoupleFound = false;
    Object.keys(roles).forEach((key) => {
      if (
        roles[key] &&
        (item.includes(roles[key]["herEmail"]) ||
          item.includes(roles[key]["hisEmail"]))
      ) {
        isCoupleFound = true;
        setCoupleForRoleToRemove(true);
      }
    });

    if (isCoupleFound) {
      return;
    }

    setEditIndex(item);
    setRemoveAccessModal(true);
  };

  const handleAccessRmvClose = () => {
    setRemoveAccessModal(false);
  };

  const removeCoupleFromRetreat = () => {
    retreatRoasterApi
      .removeCoupleFromRetreat({
        coupleId: editIndex.coupleId,
        retreatId: ediUserIdClicked,
      })
      .then((res) => {
        toast.success(res.msg);
        getRolesOfRetreats(ediUserIdClicked);
        handleRemoveClose();
        setEditIndex("");
        setRemoveCoupleModal(false);
      })
      .catch((error) => {
        console.error(error);
        toast.error("An error occurred while uploading the image.");
      });
  };

  const handleClose = () => {
    setShow(false);
  };

  const removeCoupleImage = () => {
    setIsTempUpload(false);
    adminApi
      .removeCoupleImage({
        id: editIndex.coupleId,
        rosterId: editIndex.rosterId,
      })
      .then((res) => {
        getRolesOfRetreats(ediUserIdClicked);
        closeModel();
        setEditIndex("");
        toast.success(res.msg);
      })
      .catch((error) => {
        console.error(error);
        toast.error("An error occurred while uploading the image.");
      });
  };

  const closeModel = () => {
    setShowDeleteModal(false);
    setMailSample(false);
        setDescriptionSample(false);
  };

  const removeAccessFromRetreat = () => {
    retreatApi
      .removeAccessFromRetreat({
        remove_access_mail: editIndex,
        retreatId: ediUserIdClicked,
      })
      .then((res) => {
        toast.success(res.msg);
        editRetreat(id);
        handleRemoveClose();
        setEditIndex("");
        setRemoveAccessModal(false);
      })
      .catch((error) => {
        console.error(error);
        toast.error("An error occurred while uploading the image.");
      });
  };

  const handleImageChanges = (e, coupleDta) => {
    let { name, value } = e.target;
    if (coupleDta) {
      switch (coupleDta.role) {
        case "Lead":
          setLeadCoupleLoader(true);
          break;
        case "Co-Lead":
          setCoLeadCoupleLoader(true);
          break;
        // case "Shadow Lead":
        //   setShadowLeadCoupleLoader(true);
        //   break;
        // case "Spiritual Director":
        //   setSpiritualDirectorLoader(true);
        //   break;
        // case "Spiritual Mentor":
        //   setSpiritualMentorLoader(true);
        //   break;
        case "Mentor":
          setMentorLoader(true);
          break;
        default:
          // Handle any other case if necessary
          break;
      }
    } else {
      // Handle the case when coupleDta is null or undefined
      setMentorLoader(true);
    }
    if (name === "imageUrl6" && e.target.files && e.target.files.length > 0) {
      let allData = new FormData();
      allData.append("file", e.target.files[0]);
      allData.append("coupleId", coupleDta.coupleId);
      if (coupleDta.rosterId) {
        allData.append("rosterId", coupleDta.rosterId);
      }
      adminApi
        .saveCoupleImage(allData)
        .then((res) => {
          getRolesOfRetreats(ediUserIdClicked);
          setLeadCoupleLoader(false);
          setCoLeadCoupleLoader(false);
          // setShadowLeadCoupleLoader(false);
          setSpiritualDirectorLoader(false);
          setSpiritualMentorLoader(false);
          setMentorLoader(false);
          toast.success("Couple image uploaded successfully.");
        })
        .catch((error) => {
          console.error(error);
          setLeadCoupleLoader(false);
          setCoLeadCoupleLoader(false);
          // setShadowLeadCoupleLoader(false);
          setSpiritualDirectorLoader(false);
          setSpiritualMentorLoader(false);
          setMentorLoader(false);
          toast.error("An error occurred while uploading the image.");
        });
    } else {
      setLeadCoupleLoader(false);
      setCoLeadCoupleLoader(false);
      // setShadowLeadCoupleLoader(false);
      setSpiritualDirectorLoader(false);
      setSpiritualMentorLoader(false);
      setMentorLoader(false);
      toast.error("Please select an image.");
    }
  };

  const handleTimeChange = (name, value, index) => {
    const newData = { ...data };

    // Ensure the schedule array has an entry at the specified index
    if (!newData.schedule[index]) {
      newData.schedule[index] = {};
    }

    if (name.includes("date")) {
      const isValid = value && moment(value).isValid();
      if (isValid) {
        // Adjust the date for the specified timezone
        const adjustedDate = moment(value)
          .tz("America/New_York", true)
          .format("ddd MMM DD YYYY HH:mm:ss [GMT]ZZ (z)");

        // Set the date property for the schedule entry at the given index
        newData.schedule[index].date = adjustedDate;

        // Auto-fill other dates
        if (index === 0) {
          // Friday selected, set Saturday and Sunday
          const satDate = moment(value).add(1, "days");
          const sunDate = moment(value).add(2, "days");
          if (!newData.schedule[1]) newData.schedule[1] = {};
          if (!newData.schedule[2]) newData.schedule[2] = {};
          newData.schedule[1].date = satDate
            .tz("America/New_York", true)
            .format("ddd MMM DD YYYY HH:mm:ss [GMT]ZZ (z)");
          newData.schedule[2].date = sunDate
            .tz("America/New_York", true)
            .format("ddd MMM DD YYYY HH:mm:ss [GMT]ZZ (z)");
        } else if (index === 1) {
          // Saturday selected, set Friday and Sunday
          const friDate = moment(value).subtract(1, "days");
          const sunDate = moment(value).add(1, "days");
          if (!newData.schedule[0]) newData.schedule[0] = {};
          if (!newData.schedule[2]) newData.schedule[2] = {};
          newData.schedule[0].date = friDate
            .tz("America/New_York", true)
            .format("ddd MMM DD YYYY HH:mm:ss [GMT]ZZ (z)");
          newData.schedule[2].date = sunDate
            .tz("America/New_York", true)
            .format("ddd MMM DD YYYY HH:mm:ss [GMT]ZZ (z)");
        } else if (index === 2) {
          // Sunday selected, set Friday and Saturday
          const friDate = moment(value).subtract(2, "days");
          const satDate = moment(value).subtract(1, "days");
          if (!newData.schedule[0]) newData.schedule[0] = {};
          if (!newData.schedule[1]) newData.schedule[1] = {};
          newData.schedule[0].date = friDate
            .tz("America/New_York", true)
            .format("ddd MMM DD YYYY HH:mm:ss [GMT]ZZ (z)");
          newData.schedule[1].date = satDate
            .tz("America/New_York", true)
            .format("ddd MMM DD YYYY HH:mm:ss [GMT]ZZ (z)");
        }
      } else {
        newData.schedule[index].date = "";
        if (index === 0) {
          if (newData.schedule[1]) newData.schedule[1].date = "";
          if (newData.schedule[2]) newData.schedule[2].date = "";
        } else if (index === 1) {
          if (newData.schedule[0]) newData.schedule[0].date = "";
          if (newData.schedule[2]) newData.schedule[2].date = "";
        } else if (index === 2) {
          if (newData.schedule[0]) newData.schedule[0].date = "";
          if (newData.schedule[1]) newData.schedule[1].date = "";
        }
      }

      // Update day name based on the adjusted date and language
      newData.schedule.forEach((item) => {
        if (item.date && moment(item.date).isValid()) {
          item.dayName = getDayName(item.date, newData.language);
        } else {
          item.dayName = "";
        }
      });
    } else if (name.includes("from")) {
      // Check if "From" and "To" times are the same
      if (newData.schedule[index].to && newData.schedule[index].to === value) {
        setCheck(`${index}`);
      } else {
        setCheck("");
        newData.schedule[index].from = value;
      }
    } else if (name.includes("to")) {
      // Check if "To" and "From" times are the same
      if (
        newData.schedule[index].from &&
        newData.schedule[index].from === value
      ) {
        setCheck(`${index}`);
      } else {
        setCheck("");
        newData.schedule[index].to = value;
      }
    }
    if (
      (newData.parishId || newData.parish) &&
      newData.language &&
      newData.location &&
      newData.schedule[index].date &&
      newData.schedule[index].from &&
      newData.schedule[index].to
    ) {
      autoSaveFunction(newData);
      // getAllCouples()
    }
    setData(newData);
  };

  const subAdminPopUP = () => {
    if (
      ediUserIdClicked &&
      ediUserIdClicked !== "" &&
      ediUserIdClicked !== null
    ) {
      setCreateRetAdmin(true);
    } else {
      toast.error("Please enter the required fields.");
    }
  };

  const showIsDisabledPopUp = (retreatData, mail) => {
    setIsDisabledShow(true);
    setEditIndex({ retreatData: retreatData, mail: mail });
  };

  const closeIsDisabledPopUp = () => {
    setIsDisabledShow(false);
    setEditIndex("");
  };

  const retreatDisabledSubAdmin = () => {
    retreatApi
      .retreatDisabledSubAdmin({
        retreatData: editIndex?.retreatData,
        mail: editIndex?.mail?.label,
      })
      .then((res) => {
        toast.success(res.msg);
        closeIsDisabledPopUp();
        toast.success(res.msg);
        editRetreat(ediUserIdClicked);
        getAllCouples();
      })
      .catch((error) => {
        console.error(error);
        toast.error("An error occurred while disable/enale the sub-admin.");
      });
  };

  const retreatTeamPopUP = () => {
    if (
      ediUserIdClicked &&
      ediUserIdClicked !== "" &&
      ediUserIdClicked !== null
    ) {
      setCreateRetTeam(true);
    } else {
      toast.error("Please enter the required fields.");
    }
  };

  const handleSelectOption = (val) => {
    setCoupleSelectForAccess(val);
  };

  const handleAccessSubmit = async () => {
    if (coupleSelectForAccess && coupleSelectForAccess.length) {
      if (ediUserIdClicked) {
        let submitData = {
          coupleIds: coupleSelectForAccess.map((option) => ({
            label: option.label,
            value: option.value,
            isNew: option.__isNew__ || false,
          })),
          retreatId: ediUserIdClicked,
          isTemp: false,
        };
        setAccessGreenTick(true);
        await retreatApi
          .giveAccesssOfApprove(submitData)
          .then((res) => {
            if (res.success) {
              toast.success(res.msg);
              setCoupleSelectForAccess([]);
              editRetreat(ediUserIdClicked);
              getAllCouples();
              setTimeout(() => {
                setAccessGreenTick(false);
              }, 2000);
            } else {
              toast.error(res.msg);
              setAccessGreenTick(false);
            }
          })
          .catch((error) => {
            toast.error(error.toString());
          });
      } else {
        setCoupleSelectForAccess([]);
        toast.error("Please enter the required fields.");
      }
    } else {
      toast.error("Please select at least one sub-admin.");
    }
  };

  const coupleRoleStateKeys = {
    lead_couple: "leadCouple",
    co_lead_couple: "coLeadCouple",
    mentor_couple: "mentor",
    spiritual_mentor_couple: "spiritualMentor",
  };

  const coupleRoleApiLabels = {
    lead_couple: "Lead",
    co_lead_couple: "Co-Lead",
    mentor_couple: "Mentor",
    spiritual_mentor_couple: "Spiritual Mentor",
  };

  const handleSelectExistingCouple = async (selectedOption, role) => {
    const stateKey = coupleRoleStateKeys[role];
    if (!stateKey) return;

    if (!selectedOption) {
      setSelectedCoupleOptions((prev) => ({ ...prev, [role]: null }));
      setRoles((prev) => ({ ...prev, [stateKey]: null }));
      return;
    }

    setSelectedCoupleOptions((prev) => ({ ...prev, [role]: selectedOption }));

    const coupleData = fullCouples.find((c) => c.id === selectedOption.value);
    if (coupleData) {
      setRoles((prev) => ({
        ...prev,
        [stateKey]: {
          coupleId: coupleData.id,
          hisFirstName: coupleData.hisFirstName || "",
          hisLastName: coupleData.hisLastName || "",
          hisEmail: coupleData.hisEmail || "",
          herFirstName: coupleData.herFirstName || "",
          herLastName: coupleData.herLastName || "",
          herEmail: coupleData.herEmail || "",
        },
      }));
    }

    if (ediUserIdClicked) {
      const roleId = rolesDataList.find(
        (r) => r.label === coupleRoleApiLabels[role],
      )?.value;

      if (!roleId) return;

      let submitData = {
        roleId: roleId,
        retreatId: ediUserIdClicked,
        coupleId: selectedOption.value,
        priestId: null,
      };

      try {
        const res = await retreatRoasterApi.createLeads(submitData);
        if (res.success) {
          getRolesOfRetreats(ediUserIdClicked);
          toast.success(res.msg);
        } else {
          toast.error(res.msg);
        }
      } catch (error) {
        toast.error(error.toString());
      }
    }
  };

  const handleSelectExistingPriest = async (selectedOption) => {
    if (!selectedOption) {
      setSelectedPriestOption(null);
      setRoles((prev) => ({
        ...prev,
        spiritualDirector: null,
      }));
      return;
    }

    setSelectedPriestOption(selectedOption);
    const priestData = priestsList.find((p) => p.id === selectedOption.value);
    if (priestData) {
      setRoles((prev) => ({
        ...prev,
        spiritualDirector: {
          ...(prev?.spiritualDirector || {}),
          priestId: priestData.id,
          firstName: priestData.firstName || "",
          lastName: priestData.lastName || priestData.name || "",
          email: priestData.email || "",
          hisFirstName: priestData.firstName || "",
          hisLastName: priestData.lastName || priestData.name || "",
          hisEmail: priestData.email || "",
        },
      }));
    }

    if (ediUserIdClicked) {
      const roleId = rolesDataList.find(
        (r) => r.label === "Spiritual Director",
      )?.value;

      if (!roleId) return;

      let submitData = {
        roleId: roleId,
        retreatId: ediUserIdClicked,
        coupleId: null,
        priestId: selectedOption.value,
      };

      try {
        const res = await retreatRoasterApi.createLeads(submitData);
        if (res.success) {
          getRolesOfRetreats(ediUserIdClicked);
          toast.success(res.msg);
        } else {
          toast.error(res.msg);
        }
      } catch (error) {
        toast.error(error.toString());
      }
    }
  };

  const handleRetreatTeam = (e, role) => {
    const { name, value } = e.target;
    const fieldKey = coupleRoleStateKeys[role] || "spiritualDirector";
    setRoles((prev) => ({
      ...prev,
      [fieldKey]: {
        ...(prev[fieldKey] || {}),
        [name]: value,
      },
    }));
  };

  const getCoupleRoleValue = (role, field) => {
    const stateKey = coupleRoleStateKeys[role];
    return roles?.[stateKey]?.[field] || "";
  };

  const coupleOptions = allCoupleData;
  const priestOptions = (priestsList || []).map((item) => ({
    label: `${item.title ? item.title + " " : ""}${item.firstName} ${
      item.lastName || item.name
    } - ${item.email}`,
    value: item.id,
  }));

  return (
    <>
      <RetreatFormModal
        show={showFullEditModal}
        onHide={() => setShowFullEditModal(false)}
        isEdit={!!ediUserIdClicked}
        validated={validated}
        data={data}
        perishDataList={perishDataList}
        description={description}
        setDescription={setDescription}
        emailMsg={emailMsg}
        setEmailMsg={setEmailMsg}
        roles={roles}
        rolesDataList={rolesDataList}
        allCoupleData={allCoupleData}
        priestsList={priestsList}
        retreatId={ediUserIdClicked}
        getRolesOfRetreats={getRolesOfRetreats}
        onTeamChange={refreshRetreatAdmins}
        onPeopleRefresh={() => {
          getAllCouples();
          getPriestsList();
        }}
        setEditIndex={setEditIndex}
        editIndex={editIndex}
        allCoupleMails={allCoupleMails}
        coupleSelectForAccess={coupleSelectForAccess}
        accessGreenTick={accessGreenTick}
        isTempUpload1={isTempUpload1}
        check={check}
        timePickerPass={Pass}
        formattedDate={formattedDate}
        upload={upload}
        corruptedImg={corruptedImg}
        uploadRetreat={uploadRetreat}
        handleChanges={handleChanges}
        handleTimeChange={handleTimeChange}
        handleSubmit={handleSubmit}
        handleSelectOption={handleSelectOption}
        handleAccessSubmit={handleAccessSubmit}
        handlerAccessRmvShow={handlerAccessRmvShow}
        showIsDisabledPopUp={showIsDisabledPopUp}
        remove={remove}
        dynamicDescription={dynamicDescription}
        dynamicEmailMsg={dynamicEmailMsg}
      />
      <div className="cr-page">
      <div className="row ext-space">
        <div className="col-lg-12 d-flex flex-column">
          <div className="row flex-grow">
            <div className="col-12 grid-margin stretch-card">
              <div className="card custom-card">
                <div className="card-body ">
                  <Form
                    onSubmit={handleSubmit}
                    noValidate
                    validated={validated}
                    className="forms-sample"
                  >
                    <Container fluid className="create-retreat-header">
                      <div className="cr-toolbar cr-topbar">
                        <a
                          href="javascript:void(0)"
                          onClick={() => navigate(-1)}
                          className="back-link cr-btn-quiet"
                        >
                          &lt;Back
                        </a>
                        {ediUserIdClicked && ediUserIdClicked !== "" ? (
                          <h2 className="addRetHeading">Edit Retreat</h2>
                        ) : (
                          <h2 className="addRetHeading">Add New Retreat</h2>
                        )}
                        <div className="cr-toolbar-actions">
                          {ediUserIdClicked && ediUserIdClicked !== "" ? (
                            <>
                              <a
                                href={`/create-program/${ediUserIdClicked}`}
                                className="font-size"
                                target="_blank"
                              >
                                <button className="dirProgButtons cr-btn-quiet" type="button">
                                  Create Program
                                </button>
                              </a>
                              <a
                                href={`/create-directory/${ediUserIdClicked}`}
                                className="font-size"
                                target="_blank"
                              >
                                <button className="dirProgButtons cr-btn-quiet" type="button">
                                  Create Directory
                                </button>
                              </a>
                            </>
                          ) : null}
                          {ediUserIdClicked ? (
                            <a
                              href={`/registration-retreat/${ediUserIdClicked}`}
                              className="font-size"
                              target="_blank"
                            >
                              <Button
                                variant="primary"
                                className="btn-sm submitRet cr-btn-quiet"
                              >
                                Preview
                              </Button>
                            </a>
                          ) : null}
                          <Button
                            variant="primary"
                            className="btn-sm submitRet cr-btn-quiet"
                            type="button"
                            onClick={() => setShowFullEditModal(true)}
                          >
                            {ediUserIdClicked ? "Edit Details" : "Full Form"}
                          </Button>
                          <Button
                            variant="primary"
                            type="submit"
                            className="btn-sm submitRet cr-btn-solid"
                            data-cr-section="save"
                          >
                            {ediUserIdClicked && ediUserIdClicked !== ""
                              ? "Update"
                              : "Save"}
                          </Button>
                        </div>
                      </div>
                      <Row>
                        <hr className="mb-0" />
                        <Col md={4} className="left-retreat-panel">
                          <div className="scrollable-content">
                            <Modal.Body>
                              <div className="row cr-editor-stack">
                                <button
                                  type="button"
                                  className="cr-step-title"
                                  onClick={() =>
                                    setOpenSections((prev) => ({
                                      ...prev,
                                      parish: !prev.parish,
                                    }))
                                  }
                                  aria-expanded={openSections.parish}
                                >
                                  <span>1</span> Retreat Title
                                  <i className={`mdi ${openSections.parish ? "mdi-chevron-up" : "mdi-chevron-down"}`}></i>
                                </button>
                                <div
                                  className="cr-section"
                                  data-cr-section="parish"
                                  hidden={!openSections.parish}
                                >
                                <Form.Group className="form-group col-12">
                                  <Form.Label>
                                    Select Parish
                                    <span className="text-danger">*</span>
                                  </Form.Label>
                                  <Form.Select
                                    required
                                    size="sm"
                                    name="parish"
                                    id="parish"
                                    placeholder="Type"
                                    value={data && data.parish}
                                    onChange={(e) => handleChanges("", e)}
                                  >
                                    <option value="">Select</option>
                                    {perishDataList
                                      .filter(
                                        (item) =>
                                          item.parishCategoryName?.toUpperCase() !==
                                          "OTHER",
                                      )
                                      .map((item) => {
                                        return (
                                          <option
                                            key={`parish-${item.id}`}
                                            value={item.id}
                                          >
                                            {formatParishOptionLabel(item)}
                                          </option>
                                        );
                                      })}
                                  </Form.Select>

                                  <Form.Control.Feedback type="invalid">
                                    Parish is required!
                                  </Form.Control.Feedback>
                                </Form.Group>

                                <Form.Group className="form-group col-12">
                                  <Form.Label>
                                    Language{" "}
                                    <span className="text-danger">*</span>
                                  </Form.Label>
                                  <Form.Select
                                    required
                                    size="sm"
                                    type="text"
                                    name="language"
                                    id="language"
                                    placeholder="Language"
                                    value={data.language}
                                    onChange={(e) => handleChanges("", e)}
                                  >
                                    <option value="">Select</option>
                                    <option value="english">English</option>
                                    <option value="spanish">Spanish</option>
                                  </Form.Select>
                                  <Form.Control.Feedback type="invalid">
                                    Language is required!
                                  </Form.Control.Feedback>
                                </Form.Group>

                                <Form.Group className="form-group col-12">
                                  <Form.Label>
                                    Enter Location{" "}
                                    <span className="text-danger">*</span>
                                  </Form.Label>
                                  <Form.Control
                                    required
                                    size="sm"
                                    type="text"
                                    name="location"
                                    id="location"
                                    placeholder="Location"
                                    value={data.location}
                                    onBlur={(e) => {
                                      handleSubmitOnBlur(e, "location");
                                    }}
                                    onChange={(e) => handleChanges("", e)}
                                    disabled={
                                      data.parish &&
                                      perishDataList.find(
                                        (p) => p.id == data.parish,
                                      ) &&
                                      perishDataList.find(
                                        (p) => p.id == data.parish,
                                      ).address
                                    }
                                  />
                                  <Form.Control.Feedback type="invalid">
                                    Location is required!
                                  </Form.Control.Feedback>
                                </Form.Group>

                                <Form.Group className="form-group col-12">
                                  <Form.Label>Retreat Title</Form.Label>
                                  <Form.Control
                                    // required
                                    readOnly
                                    size="sm"
                                    type="text"
                                    name="title"
                                    id="title"
                                    placeholder="Retreat Title"
                                    value={data.title}
                                    className="form-control"
                                    onBlur={(e) => {
                                      handleSubmitOnBlur(e, "title");
                                    }}
                                    onChange={(e) => handleChanges("", e)}
                                  />
                                  <Form.Control.Feedback type="invalid">
                                    Retreat Title is required!
                                  </Form.Control.Feedback>
                                </Form.Group>

                                <div className="col-12 text-center ">
                                  {data.image1 == "" ||
                                  data.image1 == undefined ? (
                                    <>
                                      <input
                                        name="image1"
                                        className="pt-1"
                                        type="file"
                                        accept={RETREAT_IMAGE_ACCEPT}
                                        style={{ display: "none" }}
                                        id="retreatImageUpload1"
                                        onChange={(e) => handleChanges("", e)}
                                      />
                                      <span className="d-inline-flex align-items-center justify-content-center">
                                        <Button
                                          variant="primary"
                                          className="mb-1 me-3 text-center btn-sm upload-retreat-image"
                                          onClick={(e) => {
                                            upload("ForFirst");
                                          }}
                                        >
                                          {t("upload_retreat_image")}
                                        </Button>
                                        <RetreatImageUploadInfo />
                                      </span>
                                      {/* <span className="text-small d-block me-3">(Upload Square Image)</span> */}
                                    </>
                                  ) : (
                                    <Button
                                      variant="danger"
                                      className="mb-1 mt-2 btn-sm upload-retreat-image"
                                      onClick={(e) => {
                                        remove("ForFirst");
                                      }}
                                    >
                                      Remove Image
                                    </Button>
                                  )}
                                </div>

                                {/* <div className="col-12 text-center mt-3 mb-3">
                                  {data.image2 == "" ||
                                  data.image2 == undefined ? (
                                    <>
                                      <input
                                        name="image2"
                                        className="pt-1"
                                        type="file"
                                        accept={RETREAT_IMAGE_ACCEPT}
                                        style={{ display: "none" }}
                                        id="retreatImageUpload2"
                                        onChange={(e) => handleChanges("", e)}
                                      />

                                      <Button
                                        variant="primary"
                                        className="mb-1 me-3 text-center btn-sm upload-retreat-image"
                                        onClick={(e) => {
                                          upload("ForSecond");
                                        }}
                                      >
                                        Upload 2nd Image
                                      </Button>
                                    </>
                                  ) : (
                                    <Button
                                      variant="danger"
                                      className="mb-1 mt-2 btn-sm upload-retreat-image"
                                      onClick={(e) => {
                                        remove("ForSecond");
                                      }}
                                    >
                                      Remove 2nd image
                                    </Button>
                                  )}
                                </div> */}

                                <Form.Group className="form-group col-12">
                                  <Form.Label>Retreat Theme</Form.Label>
                                  <Form.Control
                                    // required
                                    size="sm"
                                    type="text"
                                    name="heading"
                                    id="heading"
                                    placeholder="Retreat Theme"
                                    value={data.heading}
                                    onBlur={(e) => {
                                      handleSubmitOnBlur(e, "heading");
                                    }}
                                    onChange={(e) => handleChanges("", e)}
                                  />
                                  <Form.Control.Feedback type="invalid">
                                    Retreat Theme is required!
                                  </Form.Control.Feedback>
                                </Form.Group>
                                </div>
                                <hr />
                                <button
                                  type="button"
                                  className="cr-step-title"
                                  onClick={() =>
                                    setOpenSections((prev) => ({
                                      ...prev,
                                      weekend: !prev.weekend,
                                    }))
                                  }
                                  aria-expanded={openSections.weekend}
                                >
                                  <span>2</span> Retreat Dates
                                  <i className={`mdi ${openSections.weekend ? "mdi-chevron-up" : "mdi-chevron-down"}`}></i>
                                </button>
                                <div
                                  className="cr-section cr-weekend"
                                  data-cr-section="weekend"
                                  hidden={!openSections.weekend}
                                >
                                <Col className="cr-day">
                                  <Row>
                                    <Col md={3} className="p-0">
                                      {" "}
                                      <h5>Friday</h5>
                                    </Col>
                                    <Col md={9} className="p-0">
                                      {" "}
                                      <Form.Label className="dateSize">
                                        Date{" "}
                                        <span className="text-danger">*</span>
                                      </Form.Label>
                                      <DatePicker
                                        autoComplete="off"
                                        id="dateId"
                                        dateFormat="MM-dd-yyyy"
                                        placeholderText="mm-dd-yyyy"
                                        className="form-select"
                                        selected={
                                          (() => {
                                            const dStr = data?.schedule?.[0]?.date;
                                            if (!dStr || dStr === "Invalid date") return null;
                                            const m = moment(formattedDate(dStr));
                                            return m.isValid() ? m.toDate() : null;
                                          })()
                                        }
                                        name="date0"
                                        onChange={(date) =>
                                          handleTimeChange("date0", date, 0)
                                        }
                                        filterDate={(date) =>
                                          date.getDay() === 5
                                        }
                                        renderCustomHeader={renderRetreatDateHeader}
                                      />
                                      <Form.Control.Feedback type="invalid">
                                        Atleast one date is required!
                                      </Form.Control.Feedback>
                                      <div className="dateShedule">
                                        {" "}
                                        <div>
                                          <Form.Label className="mt-2 dateSize">
                                            From
                                          </Form.Label>
                                          <TimePicker
                                            chekPicker={Pass}
                                            useTwelveHourFormat={true}
                                            showClockIcon={false}
                                            showCloseIcon={true}
                                            allowBackdrop={true}
                                            onTimeChange={(time) =>
                                              handleTimeChange("from0", time, 0)
                                            }
                                            placeholder="00 : 00 am"
                                            defaulValue="00 : 00"
                                            value={
                                              data &&
                                              data.schedule[0] &&
                                              data.schedule[0].from
                                            }
                                            className="timePicker"
                                          />
                                        </div>
                                        <div>
                                          {" "}
                                          <Form.Label className="mt-2 dateSize">
                                            To
                                          </Form.Label>
                                          <TimePicker
                                            chekPicker={Pass}
                                            useTwelveHourFormat={true}
                                            showClockIcon={false}
                                            showCloseIcon={true}
                                            allowBackdrop={true}
                                            onTimeChange={(time) =>
                                              handleTimeChange("to0", time, 0)
                                            }
                                            value={
                                              data &&
                                              data.schedule[0] &&
                                              data.schedule[0].to
                                            }
                                            placeholder="00 : 00 am"
                                            defaulValue="00 : 00"
                                            className="timePicker indexVlues"
                                          />{" "}
                                        </div>
                                      </div>
                                    </Col>
                                  </Row>
                                </Col>
                                <Col
                                  lg={12}
                                  md={12}
                                  xs={12}
                                  className="mb-3 text-center"
                                >
                                  {" "}
                                  {check && check === "0" ? (
                                    <h5 className="text-danger mt-2">
                                      Time From' and 'Time To' should not be the
                                      same.
                                    </h5>
                                  ) : null}
                                </Col>
                                <hr />
                                <Col className="cr-day">
                                  <Row>
                                    <Col md={3} className="p-0">
                                      {" "}
                                      <h5>Saturday</h5>
                                    </Col>
                                    <Col md={9} className="p-0">
                                      {" "}
                                      <Form.Label className="dateSize">
                                        Date{" "}
                                        <span className="text-danger">*</span>
                                      </Form.Label>
                                      <DatePicker
                                        autoComplete="off"
                                        id="dateId"
                                        dateFormat="MM-dd-yyyy"
                                        placeholderText="mm-dd-yyyy"
                                        className="form-select"
                                        selected={
                                          (() => {
                                            const dStr = data?.schedule?.[1]?.date;
                                            if (!dStr || dStr === "Invalid date") return null;
                                            const m = moment(formattedDate(dStr));
                                            return m.isValid() ? m.toDate() : null;
                                          })()
                                        }
                                        name="date1"
                                        onChange={(date) =>
                                          handleTimeChange("date1", date, 1)
                                        }
                                        filterDate={(date) =>
                                          date.getDay() === 6
                                        }
                                        renderCustomHeader={renderRetreatDateHeader}
                                      />
                                      <Form.Control.Feedback type="invalid">
                                        Atleast one date is required!
                                      </Form.Control.Feedback>
                                      <div className="dateShedule">
                                        {" "}
                                        <div>
                                          <Form.Label className="mt-2 dateSize">
                                            From
                                          </Form.Label>
                                          <TimePicker
                                            chekPicker={Pass}
                                            useTwelveHourFormat={true}
                                            showClockIcon={false}
                                            showCloseIcon={true}
                                            allowBackdrop={true}
                                            onTimeChange={(time) =>
                                              handleTimeChange("from1", time, 1)
                                            }
                                            placeholder="00 : 00 am"
                                            defaulValue="00 : 00"
                                            value={
                                              data &&
                                              data.schedule[1] &&
                                              data.schedule[1].from
                                            }
                                            className="timePicker"
                                          />
                                        </div>
                                        <div>
                                          {" "}
                                          <Form.Label className="mt-2 dateSize">
                                            To
                                          </Form.Label>
                                          <TimePicker
                                            chekPicker={Pass}
                                            useTwelveHourFormat={true}
                                            showClockIcon={false}
                                            showCloseIcon={true}
                                            allowBackdrop={true}
                                            onTimeChange={(time) =>
                                              handleTimeChange("to1", time, 1)
                                            }
                                            value={
                                              data &&
                                              data.schedule[1] &&
                                              data.schedule[1].to
                                            }
                                            placeholder="00 : 00 am"
                                            defaulValue="00 : 00"
                                            className="timePicker indexVlues"
                                          />{" "}
                                        </div>
                                      </div>
                                    </Col>
                                  </Row>
                                </Col>
                                <Col
                                  lg={12}
                                  md={12}
                                  xs={12}
                                  className="mb-3 text-center"
                                >
                                  {" "}
                                  {check && check === "1" ? (
                                    <h5 className="text-danger mt-2">
                                      Time From' and 'Time To' should not be the
                                      same.
                                    </h5>
                                  ) : null}
                                </Col>
                                <hr />
                                <Col className="cr-day">
                                  <Row>
                                    <Col md={3} className="p-0">
                                      {" "}
                                      <h5>Sunday</h5>
                                    </Col>
                                    <Col md={9} className="p-0">
                                      {" "}
                                      <Form.Label className="dateSize">
                                        Date{" "}
                                        <span className="text-danger">*</span>
                                      </Form.Label>
                                      <DatePicker
                                        autoComplete="off"
                                        id="dateId"
                                        dateFormat="MM-dd-yyyy"
                                        placeholderText="mm-dd-yyyy"
                                        className="form-select"
                                        selected={
                                          (() => {
                                            const dStr = data?.schedule?.[2]?.date;
                                            if (!dStr || dStr === "Invalid date") return null;
                                            const m = moment(formattedDate(dStr));
                                            return m.isValid() ? m.toDate() : null;
                                          })()
                                        }
                                        name="date2"
                                        onChange={(date) =>
                                          handleTimeChange("date2", date, 2)
                                        }
                                        filterDate={(date) =>
                                          date.getDay() === 0
                                        }
                                        renderCustomHeader={renderRetreatDateHeader}
                                      />
                                      <Form.Control.Feedback type="invalid">
                                        Atleast one date is required!
                                      </Form.Control.Feedback>
                                      <div className="dateShedule">
                                        {" "}
                                        <div>
                                          <Form.Label className="mt-2 dateSize">
                                            From
                                          </Form.Label>
                                          <TimePicker
                                            chekPicker={Pass}
                                            useTwelveHourFormat={true}
                                            showClockIcon={false}
                                            showCloseIcon={true}
                                            allowBackdrop={true}
                                            onTimeChange={(time) =>
                                              handleTimeChange("from2", time, 2)
                                            }
                                            placeholder="00 : 00 am"
                                            defaulValue="00 : 00"
                                            value={
                                              data &&
                                              data.schedule[2] &&
                                              data.schedule[2].from
                                            }
                                            className="timePicker"
                                          />
                                        </div>
                                        <div>
                                          {" "}
                                          <Form.Label className="mt-2 dateSize">
                                            To
                                          </Form.Label>
                                          <TimePicker
                                            chekPicker={Pass}
                                            useTwelveHourFormat={true}
                                            showClockIcon={false}
                                            showCloseIcon={true}
                                            allowBackdrop={true}
                                            onTimeChange={(time) =>
                                              handleTimeChange("to2", time, 2)
                                            }
                                            value={
                                              data &&
                                              data.schedule[2] &&
                                              data.schedule[2].to
                                            }
                                            placeholder="00 : 00 am"
                                            defaulValue="00 : 00"
                                            className="timePicker indexVlues"
                                          />{" "}
                                        </div>
                                      </div>
                                    </Col>
                                  </Row>
                                </Col>
                                <Col
                                  lg={12}
                                  md={12}
                                  xs={12}
                                  className="mb-3 text-center"
                                >
                                  {" "}
                                  {check && check === "2" ? (
                                    <h5 className="text-danger mt-2">
                                      Time From' and 'Time To' should not be the
                                      same.
                                    </h5>
                                  ) : null}
                                </Col>
                                </div>
                                <div id="section-5"> </div>
                                <button
                                  type="button"
                                  className="cr-step-title"
                                  onClick={() =>
                                    setOpenSections((prev) => ({
                                      ...prev,
                                      story: !prev.story,
                                    }))
                                  }
                                  aria-expanded={openSections.story}
                                >
                                  <span>3</span> Retreat Details
                                  <i className={`mdi ${openSections.story ? "mdi-chevron-up" : "mdi-chevron-down"}`}></i>
                                </button>
                                <div
                                  className="cr-section"
                                  data-cr-section="story"
                                  hidden={!openSections.story}
                                >
                                <Form.Group
                                  className="form-group col-12"
                                  controlId="exampleForm.ControlTextarea1"
                                >
                                  <Form.Label>Mission Statement</Form.Label>
                                  <SunEditor
                                    id="mission-statement-editor"
                                    // autoFocus={false}
                                    type="text"
                                    onBlur={(e) => {
                                      if (
                                        missionStatement != e.target.innerHTML
                                      ) {
                                        handleSubmitOnBlur(
                                          e,
                                          "mission_statement",
                                        );
                                      }
                                    }}
                                    onChange={(e) => setMissionStatement(e)}
                                    setContents={missionStatement}
                                    name="mission_statement"
                                    inputProps={{}}
                                    setOptions={{
                                      buttonList: [
                                        [
                                          "undo",
                                          "redo",
                                          "font",
                                          "fontSize",
                                          "formatBlock",
                                        ],
                                        [
                                          "bold",
                                          "underline",
                                          "italic",
                                          "removeFormat",
                                        ],
                                        [
                                          "fontColor",
                                          "hiliteColor",
                                          "outdent",
                                          "indent",
                                          "align",
                                          "horizontalRule",
                                          "list",
                                        ],
                                        ["fullScreen", "link", "save"],
                                      ],
                                    }}
                                  />

                                  <Form.Control.Feedback type="invalid">
                                    Mission Statement is required!
                                  </Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group
                                  className="form-group col-12"
                                  controlId="exampleForm.ControlTextarea1"
                                >
                                  <div className="mailMsgText">
                                    {" "}
                                    <Form.Label>Description</Form.Label>
                                    <span
                                      className="viewMsg"
                                      onClick={() => {
                                        loadDescriptionAndEmailSamples(
                                          data?.language,
                                        );
                                        setDescriptionSample(true);
                                      }}
                                    >
                                      Description Sample
                                    </span>
                                  </div>

                                  <SunEditor
                                    id="description-editor"
                                    type="text"
                                    height="250px"
                                    onBlur={(e) => {
                                      handleSubmitOnBlur(e, "description");
                                    }}
                                    onChange={(e) => setDescription(e)}
                                    setContents={description}
                                    name="description"
                                    inputProps={{}}
                                    setOptions={{
                                      buttonList: [
                                        [
                                          "undo",
                                          "redo",
                                          "font",
                                          "fontSize",
                                          "formatBlock",
                                        ],
                                        [
                                          "bold",
                                          "underline",
                                          "italic",
                                          "removeFormat",
                                        ],
                                        [
                                          "fontColor",
                                          "hiliteColor",
                                          "outdent",
                                          "indent",
                                          "align",
                                          "horizontalRule",
                                          "list",
                                        ],
                                        ["fullScreen", "link", "save"],
                                      ],
                                    }}
                                  />
                                  <Form.Control.Feedback type="invalid">
                                    Description is required!
                                  </Form.Control.Feedback>
                                </Form.Group>

                                <Form.Group
                                  className="form-group col-12"
                                  controlId="exampleForm.ControlTextarea1"
                                >
                                  <div className="mailMsgText">
                                    {" "}
                                    <Form.Label>Email Message</Form.Label>
                                    <span
                                      className="viewMsg"
                                      onClick={() => setMailMsgView(true)}
                                    >
                                      Preview Email
                                    </span>
                                  </div>
                                  <div className="sampleMail">
                                    {" "}
                                    <span
                                      className="viewMsg"
                                      onClick={() => {
                                        loadDescriptionAndEmailSamples(
                                          data?.language,
                                        );
                                        setMailSample(true);
                                      }}
                                    >
                                      Sample Email Message
                                    </span>
                                  </div>

                                  <SunEditor
                                    id="mail-msg-editor"
                                    type="text"
                                    height="250px"
                                    onBlur={(e) => {
                                      handleSubmitOnBlur(e, "mail_msg");
                                    }}
                                    onChange={(e) => setEmailMsg(e)}
                                    setContents={emailMsg}
                                    name="mail_msg"
                                    inputProps={{}}
                                    setOptions={{
                                      buttonList: [
                                        [
                                          "undo",
                                          "redo",
                                          "font",
                                          "fontSize",
                                          "formatBlock",
                                        ],
                                        [
                                          "bold",
                                          "underline",
                                          "italic",
                                          "removeFormat",
                                        ],
                                        [
                                          "fontColor",
                                          "hiliteColor",
                                          "outdent",
                                          "indent",
                                          "align",
                                          "horizontalRule",
                                          "list",
                                        ],
                                        ["fullScreen", "link", "save", "image"],
                                      ],
                                    }}
                                  />
                                  <Form.Control.Feedback type="invalid">
                                    Email message is required!
                                  </Form.Control.Feedback>
                                </Form.Group>
                                </div>

                                <button
                                  type="button"
                                  className="cr-step-title"
                                  onClick={() =>
                                    setOpenSections((prev) => ({
                                      ...prev,
                                      payment: !prev.payment,
                                    }))
                                  }
                                  aria-expanded={openSections.payment}
                                >
                                  <span>4</span> Payment
                                  <i className={`mdi ${openSections.payment ? "mdi-chevron-up" : "mdi-chevron-down"}`}></i>
                                </button>
                                <Col
                                  lg={12}
                                  md={12}
                                  xs={12}
                                  className="cr-section"
                                  data-cr-section="payment"
                                  hidden={!openSections.payment}
                                >
                                  <Form.Group className="form-group col-12">
                                    <Form.Label>
                                      Retreat Payment Link <span className="text-danger">*</span>
                                    </Form.Label>
                                    <Form.Control
                                      required
                                      size="sm"
                                      type="text"
                                      name="paymentLink"
                                      id="paymentLink"
                                      placeholder="Retreat Payment Link"
                                      value={data.paymentLink}
                                      onBlur={(e) => {
                                        handleSubmitOnBlur(e, "paymentLink");
                                      }}
                                      onChange={(e) => handleChanges("", e)}
                                      // readOnly={isEditAdmin}
                                    />
                                    <Form.Control.Feedback type="invalid">
                                      Payment link is required!
                                    </Form.Control.Feedback>
                                  </Form.Group>
                                </Col>

                                <hr className="mb-0" />
                                <button
                                  type="button"
                                  className="cr-step-title"
                                  onClick={() =>
                                    setOpenSections((prev) => ({
                                      ...prev,
                                      team: !prev.team,
                                    }))
                                  }
                                  aria-expanded={openSections.team}
                                >
                                  <span>5</span> Team
                                  <i className={`mdi ${openSections.team ? "mdi-chevron-up" : "mdi-chevron-down"}`}></i>
                                </button>
                                <div
                                  className="cr-section cr-team"
                                  data-cr-section="team"
                                  hidden={!openSections.team}
                                >
                                <Col
                                  lg={12}
                                  md={12}
                                  sm={12}
                                  xs={12}
                                  className="col-12 text-center add-role-in-program"
                                >
                                  <div className="retreatOpenPopUp d-flex justify-content-between align-items-center mb-3">
                                    <h5 className="mb-0">Retreat Team</h5>
                                    <i
                                      type="button"
                                      onClick={() => retreatTeamPopUP()}
                                      className="mdi mdi-plus-circle btn-icon-prepend plus-icon-role "
                                      style={{
                                        fontSize: "1.8rem",
                                        cursor: "pointer",
                                      }}
                                    ></i>
                                  </div>
                                </Col>
                                <hr className="mb-0" />
                                <Col
                                  lg={12}
                                  md={12}
                                  sm={12}
                                  xs={12}
                                  className="col-12 text-center add-role-in-program"
                                >
                                  <div className="retreatOpenPopUp d-flex justify-content-between align-items-center mb-3">
                                    <h5 className="mb-0 administratorsHeader">
                                      Retreat Administrators
                                      <span
                                        title="Retreat Administrators manage the retreat data. The Lead, Co-Lead, and Mentor function as Retreat Administrators. The Super Admin has the authority to add additional Retreat Administrators."
                                        className="administratorsTitleRegister"
                                      >
                                        <i className="mdi mdi-information-outline"></i>
                                      </span>
                                    </h5>
                                    <i
                                      type="button"
                                      onClick={() => subAdminPopUP()}
                                      className="mdi mdi-plus-circle btn-icon-prepend plus-icon-role"
                                      style={{
                                        fontSize: "1.8rem",
                                        cursor: "pointer",
                                      }}
                                    ></i>
                                  </div>

                                  {data?.userEmails?.map((item, index) => (
                                    <div
                                      key={index}
                                      className="d-flex align-items-center justify-content-between border rounded px-3 py-2 mb-2"
                                    >
                                      <div className="d-flex align-items-center flex-grow-1">
                                        <input
                                          type="checkbox"
                                          className="form-check-input me-2"
                                          style={{
                                            transform: "scale(1.3)",
                                            cursor: "pointer",
                                          }}
                                          onChange={() =>
                                            showIsDisabledPopUp(data, item)
                                          }
                                          checked={item.isDisabled !== true}
                                        />
                                        <span
                                          className="fw-medium email-text"
                                          title={item.label} // Tooltip for full email
                                        >
                                          {item.label}
                                        </span>
                                      </div>
                                      <i
                                        className="mdi mdi-delete-forever text-danger"
                                        style={{
                                          fontSize: "1.3rem",
                                          cursor: "pointer",
                                        }}
                                        onClick={() =>
                                          handlerAccessRmvShow(item.label)
                                        }
                                        title="Remove Sub-Admin"
                                      ></i>
                                    </div>
                                  ))}
                                </Col>
                                </div>
                              </div>
                            </Modal.Body>
                          </div>
                        </Col>
                        <Col md={8} className="right-retreat-panel">
                          <div className="cr-preview-frame">
                          <div className="scrollable-content">
                            <div className="rr-preview-scope rr-page-wrapper">
                              <RetreatPublicView
                                showChrome
                                retreat={{
                                  ...data,
                                  mission_statement: missionStatement,
                                  description,
                                }}
                                roles={roles}
                                heroLoading={applyLoader}
                                resolveHeroImage={getRetreatImagePreviewSrc}
                                onHeroImageError={(e) => {
                                  e.target.onerror = null;
                                  e.target.src = corruptedImg;
                                }}
                                resolveCoupleImage={(url) => url || ""}
                                leaderLoading={{
                                  leadCouple: leadCoupleLoader,
                                  coLeadCouple: coLeadCoupleLoader,
                                  mentor: mentorLoader,
                                }}
                                renderLeaderActions={(couple) =>
                                  couple ? (
                                    <>
                                      <div className="text-center">
                                        {couple.imageUrl == "" ||
                                        couple.imageUrl == undefined ? (
                                          <>
                                            <input
                                              name="imageUrl6"
                                              className="pt-1"
                                              type="file"
                                              accept="image/*"
                                              style={{ display: "none" }}
                                              id={`${couple.coupleId}-CoupleProfileUpload`}
                                              onChange={(e) =>
                                                handleImageChanges(e, couple)
                                              }
                                            />
                                            <i
                                              onClick={() =>
                                                upload(couple.coupleId)
                                              }
                                              className="mdi mdi-upload text-lg text-primary font-size retreatCouples"
                                              title="Couple Image Upload"
                                            ></i>
                                          </>
                                        ) : (
                                          <i
                                            className="mdi mdi-delete-circle text-md text-danger mx-2 font-size retreatCouples"
                                            onClick={() => showModal(couple)}
                                            title="Remove Couple Image"
                                          ></i>
                                        )}
                                      </div>
                                      <i
                                        className="mdi mdi-delete-forever text-md mx-2 font-size remove_couple"
                                        onClick={() => handlerRemoveShow(couple)}
                                        title="Remove Couple"
                                      ></i>
                                    </>
                                  ) : null
                                }
                              />
                            </div>
                            <div className="rr-form-header mt-4">
                              <h3 className="RegisTitle rr-form-title">
                                {t("registration_form")}
                              </h3>
                              <div className="requiredFieldMsg rr-required-notice">
                                <span className="highlightedText">
                                  {t("highlighted_text")}
                                </span>
                                <a
                                  href="/create-ticket"
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  className="cr-preview-help"
                                >
                                  <span className="helpMdi">{t("help")}</span>
                                  <i className="mdi mdi-help-circle"></i>
                                </a>
                              </div>
                            </div>
                            <div className="row w-100 mx-0">
                              <div className="col-lg-10 mx-auto">
                                <div className="auth-form-light text-left view-register rr-glass-card py-4 px-3 px-sm-4">
                                  {/* <h4 className="text-danger mb-5">
                                    Please enter at least one Name and Email for
                                    registration.
                                  </h4> */}

                                  <Form
                                    onSubmit={handleSubmit}
                                    noValidate
                                    validated={validated}
                                    className="forms-sample formStyle"
                                  >
                                    <Row>
                                      <Col lg={12} md={12} xs={12}>
                                        <div>
                                          {" "}
                                          <label
                                            className="bold mt-2"
                                            htmlFor="exampleInputEmail1"
                                          >
                                            {t("retreat_team")}
                                            <span className="text-danger">
                                              *
                                            </span>
                                          </label>
                                          <Form.Group className="d-flex gap-3 mt-2 rr-radio-group">
                                            <div className="rr-radio-card">
                                              <Form.Check
                                                required
                                                disabled
                                                type={"radio"}
                                                id={`retreadRad`}
                                                onChange={(e) => {
                                                  handleChanges(e);
                                                }}
                                                value={"Retreatant"}
                                                label={`${t("retreatant")}`}
                                                name="attendeeType"
                                                className="space_lef1"
                                              />
                                            </div>
                                            <div className="rr-radio-card">
                                              <Form.Check
                                                required
                                                disabled
                                                type={"radio"}
                                                id={`coupleRad`}
                                                onChange={(e) => {
                                                  handleChanges(e);
                                                }}
                                                value={`Team`}
                                                label={`${t("team")}`}
                                                className="space_lef1"
                                                name="attendeeType"
                                              />
                                            </div>
                                          </Form.Group>
                                        </div>
                                        <div>
                                          {" "}
                                          <label
                                            className="bold mt-2"
                                            htmlFor="exampleInputEmail1"
                                          >
                                            {" "}
                                            {t("check_year")}
                                          </label>
                                          <label className="rr-age-note">
                                            <input
                                              type="checkbox"
                                              disabled
                                              className="form-check-input ageLabel"
                                              name="under_age_35"
                                              checked={
                                                data.under_age_35 === "YES"
                                                  ? true
                                                  : false
                                              }
                                            />
                                            {t("yes")}
                                            <i className="input-helper"></i>
                                          </label>
                                        </div>
                                      </Col>
                                      {/* <Col lg={6} md={6} xs={12}>
                                        <div className="edit-profile-img mb-2 retreat_img text-center">
                                          <img src={Profile} />
                                        </div>
                                        <div className="text-center mt-3">
                                          <Button
                                            disabled
                                            variant="primary"
                                            className="mb-1 me-3 text-center"
                                            onClick={(e) => {
                                              upload();
                                            }}
                                          >
                                            Upload Profile Image
                                          </Button>
                                        </div>
                                      </Col> */}
                                    </Row>
                                    <hr></hr>
                                    <Row>
                                      <Col lg={6} md={6} xs={12}>
                                        <div id="his-info" className="rr-gender-card rr-his-card">
                                          <span className="rr-gender-badge-his">
                                            <i className="mdi mdi-account-tie"></i>{" "}
                                            {t("his_info")}
                                          </span>
                                          <Col lg={12} md={12} xs={12}>
                                            <Form.Group className="form-group">
                                              <Form.Label className="his-info">
                                                {t("his_first_name")}
                                              </Form.Label>
                                              <Form.Control
                                                // required
                                                size="sm"
                                                type="text"
                                                name="hisFirstName"
                                                id="hisFirstName"
                                                placeholder={`${t(
                                                  "his_first_name",
                                                )}`}
                                                // value={data.hisFirstName}
                                                className="form-control his-info-border"
                                                disabled
                                                // onChange={(e) => handleChanges(e)}
                                              />
                                              <Form.Control.Feedback type="invalid">
                                                FirstName is required!
                                              </Form.Control.Feedback>
                                            </Form.Group>
                                          </Col>
                                          <Col lg={12} md={12} xs={12}>
                                            <Form.Group className="form-group">
                                              <Form.Label>
                                                {t("his_last_name")}
                                              </Form.Label>
                                              <Form.Control
                                                // required
                                                size="sm"
                                                type="text"
                                                name="hisLastName"
                                                id="hisLastName"
                                                placeholder={`${t(
                                                  "his_last_name",
                                                )}`}
                                                disabled
                                                // value={data.hisLastName}
                                                className="form-control"
                                                // onChange={(e) => handleChanges(e)}
                                              />
                                              <Form.Control.Feedback type="invalid">
                                                LastName is required!
                                              </Form.Control.Feedback>
                                            </Form.Group>
                                          </Col>
                                          <Col lg={12} md={12} xs={12}>
                                            <Form.Group className="form-group col">
                                              <Form.Label>
                                                {t("his_email")}
                                              </Form.Label>
                                              <Form.Control
                                                // required
                                                disabled
                                                size="sm"
                                                type="text"
                                                name="hisEmail"
                                                id="hisEmail"
                                                placeholder={`${t(
                                                  "his_email",
                                                )}`}
                                                // value={data.hisEmail}
                                                // onChange={(e) => handleChanges(e)}
                                              />
                                              <Form.Control.Feedback type="invalid">
                                                Email is required!
                                              </Form.Control.Feedback>
                                            </Form.Group>
                                          </Col>
                                          <Col lg={12} md={12} xs={12}>
                                            <Form.Group className="form-group col">
                                              <Form.Label>
                                                {t("his_mobile")}
                                              </Form.Label>
                                              <Form.Control
                                                // required
                                                disabled
                                                size="sm"
                                                type="text"
                                                name="hisMobile"
                                                id="hisMobile"
                                                placeholder={`${t(
                                                  "his_mobile",
                                                )}`}
                                                // value={data.hisMobile}
                                                // onChange={(e) => handleChanges(e)}
                                              />
                                              <Form.Control.Feedback type="invalid">
                                                Mobile is required!
                                              </Form.Control.Feedback>
                                            </Form.Group>
                                          </Col>
                                        </div>
                                      </Col>
                                      <Col lg={6} md={6} xs={12}>
                                        <div id="her-info" className="rr-gender-card rr-her-card">
                                          <span className="rr-gender-badge-her">
                                            <i className="mdi mdi-account-heart"></i>{" "}
                                            {t("her_info")}
                                          </span>
                                          <Col lg={12} md={12} xs={12}>
                                            <Form.Group className="form-group">
                                              <Form.Label className="her-info">
                                                {t("her_first_name")}
                                              </Form.Label>
                                              <Form.Control
                                                // required
                                                disabled
                                                size="sm"
                                                type="text"
                                                name="herFirstName"
                                                id="herFirstName"
                                                placeholder={`${t(
                                                  "her_first_name",
                                                )}`}
                                                // value={data.herFirstName}
                                                // onChange={(e) => handleChanges(e)}
                                                className="her-info-border"
                                              />
                                              <Form.Control.Feedback type="invalid">
                                                FirstName is required!
                                              </Form.Control.Feedback>
                                            </Form.Group>
                                          </Col>
                                          <Col lg={12} md={12} xs={12}>
                                            <Form.Group className="form-group">
                                              <Form.Label>
                                                {t("her_last_name")}
                                              </Form.Label>
                                              <Form.Control
                                                // required
                                                disabled
                                                size="sm"
                                                type="text"
                                                name="herLastName"
                                                id="herLastName"
                                                placeholder={`${t(
                                                  "her_last_name",
                                                )}`}
                                                // value={data.herLastName}
                                                // onChange={(e) => handleChanges(e)}
                                              />
                                              <Form.Control.Feedback type="invalid">
                                                LastName is required!
                                              </Form.Control.Feedback>
                                            </Form.Group>
                                          </Col>
                                          <Col lg={12} md={12} xs={12}>
                                            <Form.Group className="form-group">
                                              <Form.Label>
                                                {t("her_email")}
                                              </Form.Label>
                                              <Form.Control
                                                // required
                                                disabled
                                                size="sm"
                                                type="text"
                                                name="herEmail"
                                                id="herEmail"
                                                placeholder={`${t(
                                                  "her_email",
                                                )}`}
                                                // value={data.herEmail}
                                                // onChange={(e) => handleChanges(e)}
                                              />
                                              <Form.Control.Feedback type="invalid">
                                                Email is required!
                                              </Form.Control.Feedback>
                                            </Form.Group>
                                          </Col>
                                          <Col lg={12} md={12} xs={12}>
                                            <Form.Group className="form-group">
                                              <Form.Label>
                                                {t("her_mobile")}
                                              </Form.Label>
                                              <Form.Control
                                                // required
                                                disabled
                                                size="sm"
                                                type="text"
                                                name="herMobile"
                                                id="herMobile"
                                                placeholder={`${t(
                                                  "her_mobile",
                                                )}`}
                                                // value={data.herMobile}
                                                // onChange={(e) => handleChanges(e)}
                                              />
                                              <Form.Control.Feedback type="invalid">
                                                Mobile is required!
                                              </Form.Control.Feedback>
                                            </Form.Group>
                                          </Col>
                                        </div>
                                      </Col>
                                    </Row>
                                    <hr></hr>
                                    <div className="row locationFields rr-section-card">
                                      <Form.Group className="form-group col-xs-12 col-sm-12 col-md-6 col-lg-6">
                                        <Form.Label>{t("address")}</Form.Label>
                                        <Form.Control
                                          // required
                                          disabled
                                          size="sm"
                                          type="text"
                                          name="address"
                                          id="address"
                                          placeholder={`${t("address")}`}
                                          //   value={data.address}
                                          //   onChange={(e) => handleChanges(e)}
                                        />
                                        <Form.Control.Feedback type="invalid">
                                          Address is required!
                                        </Form.Control.Feedback>
                                      </Form.Group>
                                      <Form.Group className="form-group col-xs-12 col-sm-12 col-md-6 col-lg-6">
                                        <Form.Label>{t("state")}</Form.Label>
                                        <Form.Select
                                          className="minimal locationDropdown"
                                          size="sm"
                                          type="text"
                                          name="state"
                                          id="state"
                                          placeholder="State"
                                          disabled
                                          //   value={data.state}
                                          //   onChange={(e) => handleChanges(e)}
                                        >
                                          <option value="">
                                            {t("select_state")}
                                          </option>
                                          <option value="Alaska">Alaska</option>
                                          <option value="Alabama">
                                            Alabama
                                          </option>
                                          <option value="Arkansas">
                                            Arkansas
                                          </option>
                                          <option value="Arizona">
                                            Arizona
                                          </option>
                                          <option value="California">
                                            California
                                          </option>
                                          <option value="Colorado">
                                            Colorado
                                          </option>
                                          <option value="Connecticut">
                                            Connecticut
                                          </option>
                                          <option value="District of Columbia">
                                            District of Columbia
                                          </option>
                                          <option value="Delaware">
                                            Delaware
                                          </option>
                                          <option value="Florida">
                                            Florida
                                          </option>
                                          <option value="Georgia">
                                            Georgia
                                          </option>
                                          <option value="Hawaii">Hawaii</option>
                                          <option value="Iowa">Iowa</option>
                                          <option value="Idaho">Idaho</option>
                                          <option value="Illinois">
                                            Illinois
                                          </option>
                                          <option value="Indiana">
                                            Indiana
                                          </option>
                                          <option value="Kansas">Kansas</option>
                                          <option value="Kentucky">
                                            Kentucky
                                          </option>
                                          <option value="Louisiana">
                                            Louisiana
                                          </option>
                                          <option value="Massachusetts">
                                            Massachusetts
                                          </option>
                                          <option value="Maryland">
                                            Maryland
                                          </option>
                                          <option value="Maine">Maine</option>
                                          <option value="Michigan">
                                            Michigan
                                          </option>
                                          <option value="Minnesota">
                                            Minnesota
                                          </option>
                                          <option value="Missouri">
                                            Missouri
                                          </option>
                                          <option value="Mississippi">
                                            Mississippi
                                          </option>
                                          <option value="Montana">
                                            Montana
                                          </option>
                                          <option value="North Carolina<">
                                            North Carolina
                                          </option>
                                          <option value="North Dakota">
                                            North Dakota
                                          </option>
                                          <option value="Nebraska">
                                            Nebraska
                                          </option>
                                          <option value="New Hampshire">
                                            New Hampshire
                                          </option>
                                          <option value="New Jersey">
                                            New Jersey
                                          </option>
                                          <option value="New Mexico">
                                            New Mexico
                                          </option>
                                          <option value="Nevada">Nevada</option>
                                          <option value="New York">
                                            New York
                                          </option>
                                          <option value="Ohio">Ohio</option>
                                          <option value="Oklahoma">
                                            Oklahoma
                                          </option>
                                          <option value="Oregon">Oregon</option>
                                          <option value="Pennsylvania">
                                            Pennsylvania
                                          </option>
                                          <option value="Puerto Rico">
                                            Puerto Rico
                                          </option>
                                          <option value="Rhode Island">
                                            Rhode Island
                                          </option>
                                          <option value="South Carolina">
                                            South Carolina
                                          </option>
                                          <option value="South Dakota">
                                            South Dakota
                                          </option>
                                          <option value="Tennessee">
                                            Tennessee
                                          </option>
                                          <option value="Texas">Texas</option>
                                          <option value="Utah">Utah</option>
                                          <option value="Virginia">
                                            Virginia
                                          </option>
                                          <option value="Vermont">
                                            Vermont
                                          </option>
                                          <option value="Washington">
                                            Washington
                                          </option>
                                          <option value="Wisconsin">
                                            Wisconsin
                                          </option>
                                          <option value="West Virginia">
                                            West Virginia
                                          </option>
                                          <option value="Wyoming">
                                            Wyoming
                                          </option>
                                        </Form.Select>
                                        <Form.Control.Feedback type="invalid">
                                          State is required!
                                        </Form.Control.Feedback>
                                      </Form.Group>

                                      <Form.Group className="form-group col-xs-12 col-sm-12 col-md-6 col-lg-6">
                                        <Form.Label>{t("city")}</Form.Label>
                                        <Form.Control
                                          // required
                                          disabled
                                          size="sm"
                                          type="text"
                                          name="city"
                                          id="city"
                                          placeholder={`${t("city")}`}
                                          //   value={data.city}
                                          //   onChange={(e) => handleChanges(e)}
                                        />
                                        <Form.Control.Feedback type="invalid">
                                          City is required!
                                        </Form.Control.Feedback>
                                      </Form.Group>

                                      <Form.Group className="form-group col-xs-12 col-sm-12 col-md-6 col-lg-6">
                                        <Form.Label>{t("zip")}</Form.Label>
                                        <Form.Control
                                          disabled
                                          size="sm"
                                          type="text"
                                          name="zip"
                                          id="zip"
                                          placeholder={`${t("zip")}`}
                                          value={data.zip}
                                          onChange={(e) => handleChanges(e)}
                                        />
                                        <Form.Control.Feedback type="invalid">
                                          Zip is required!
                                        </Form.Control.Feedback>
                                      </Form.Group>

                                      <Form.Group className="form-group col-xs-12 col-sm-12 col-md-6 col-lg-6">
                                        <Form.Label>{t("parish")}</Form.Label>
                                        <Select
                                          disabled
                                          name="parish"
                                          labelledBy="Select"
                                          placeholder={`${t("select_parish")}`}
                                          isSearchable={true}
                                          isMulti={false}
                                        />
                                        <Form.Control.Feedback type="invalid">
                                          Parsih is required!
                                        </Form.Control.Feedback>
                                      </Form.Group>

                                      <Form.Group className="form-group col-xs-12 col-sm-12 col-md-6 col-lg-6">
                                        <Form.Label>
                                          {t("anniversary_date")}
                                        </Form.Label>

                                        <DatePicker
                                          // required

                                          autoComplete="off"
                                          dateFormat="MM-dd-yyyy"
                                          disabled
                                          placeholderText="mm-dd-yyyy"
                                          className="form-select setdate datepicker"
                                          name="anniversary_date"
                                          id="anniversary_date"
                                          maxDate={new Date()}
                                          showDisabledMonthNavigation
                                          renderCustomHeader={({
                                            date,
                                            changeYear,
                                            changeMonth,
                                            decreaseMonth,
                                            increaseMonth,
                                            prevMonthButtonDisabled,
                                            nextMonthButtonDisabled,
                                          }) => {
                                            const years = Array.from(
                                              { length: 100 },
                                              (_, i) =>
                                                new Date().getFullYear() - i,
                                            );
                                            const months = [
                                              "January",
                                              "February",
                                              "March",
                                              "April",
                                              "May",
                                              "June",
                                              "July",
                                              "August",
                                              "September",
                                              "October",
                                              "November",
                                              "December",
                                            ];

                                            return (
                                              <div
                                                style={{
                                                  textAlign: "center",
                                                  paddingBottom: "8px",
                                                }}
                                              >
                                                {/* ✅ BIGGER Month + Year dropdowns ABOVE */}
                                                <div
                                                  style={{
                                                    marginBottom: "10px",
                                                    display: "flex",
                                                    gap: "10px",
                                                    justifyContent: "center",
                                                  }}
                                                >
                                                  {/* Month Dropdown */}
                                                  <select
                                                    style={{
                                                      fontSize: "16px",
                                                      padding: "6px 10px",
                                                      borderRadius: "6px",
                                                      border: "1px solid #ccc",
                                                    }}
                                                    value={
                                                      months[date.getMonth()]
                                                    }
                                                    onChange={({
                                                      target: { value },
                                                    }) =>
                                                      changeMonth(
                                                        months.indexOf(value),
                                                      )
                                                    }
                                                  >
                                                    {months.map((month) => (
                                                      <option
                                                        key={month}
                                                        value={month}
                                                      >
                                                        {month}
                                                      </option>
                                                    ))}
                                                  </select>

                                                  {/* Year Dropdown */}
                                                  <select
                                                    style={{
                                                      fontSize: "16px",
                                                      padding: "6px 10px",
                                                      borderRadius: "6px",
                                                      border: "1px solid #ccc",
                                                    }}
                                                    value={date.getFullYear()}
                                                    onChange={({
                                                      target: { value },
                                                    }) => changeYear(value)}
                                                  >
                                                    {years.map((year) => (
                                                      <option
                                                        key={year}
                                                        value={year}
                                                      >
                                                        {year}
                                                      </option>
                                                    ))}
                                                  </select>
                                                </div>

                                                {/* ✅ Optional month navigation below */}
                                                <div
                                                  style={{
                                                    display: "flex",
                                                    justifyContent:
                                                      "space-between",
                                                    alignItems: "center",
                                                  }}
                                                >
                                                  <button
                                                    onClick={decreaseMonth}
                                                    disabled={
                                                      prevMonthButtonDisabled
                                                    }
                                                    style={{
                                                      fontSize: "18px",
                                                      padding: "2px 8px",
                                                      cursor: "pointer",
                                                    }}
                                                  >
                                                    {"<"}
                                                  </button>

                                                  <span
                                                    style={{
                                                      fontWeight: "bold",
                                                      fontSize: "16px",
                                                    }}
                                                  >
                                                    {months[date.getMonth()]}{" "}
                                                    {date.getFullYear()}
                                                  </span>

                                                  <button
                                                    onClick={increaseMonth}
                                                    disabled={
                                                      nextMonthButtonDisabled
                                                    }
                                                    style={{
                                                      fontSize: "18px",
                                                      padding: "2px 8px",
                                                      cursor: "pointer",
                                                    }}
                                                  >
                                                    {">"}
                                                  </button>
                                                </div>
                                              </div>
                                            );
                                          }}
                                        />
                                      </Form.Group>

                                      <Form.Group className="form-group col-xs-12 col-sm-12 col-md-6 col-lg-6">
                                        <Form.Label>{t("notes")}</Form.Label>
                                        <Form.Control
                                          // required
                                          size="sm"
                                          type="text"
                                          name="notes"
                                          id="notes"
                                          placeholder={`${t("notes")}`}
                                          disabled
                                          //   value={data.notes}
                                          //   onChange={(e) => handleChanges(e)}
                                        />
                                        <Form.Control.Feedback type="invalid">
                                          Notes is required!
                                        </Form.Control.Feedback>
                                      </Form.Group>

                                      <Form.Group className="form-group col-xs-12 col-sm-12 col-md-6 col-lg-6">
                                        <Form.Label>
                                          {t("dietary_allergies")}
                                        </Form.Label>
                                        <Form.Control
                                          // required
                                          size="sm"
                                          type="text"
                                          name="allergies"
                                          id="allergies"
                                          disabled
                                          //   value={data.allergies}
                                          //   onChange={(e) => handleChanges(e)}
                                        />
                                      </Form.Group>
                                    </div>

                                    <div className="row mt-3 locationFields rr-section-card">
                                      <div className="form-group col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                        <h4 className="rr-section-title">{t("one_emergency_contact")}</h4>
                                      </div>

                                      <Form.Group className="form-group col-xs-12 col-sm-12 col-md-4 col-lg-">
                                        <Form.Label>
                                          {t("emergency_name_1")}
                                        </Form.Label>

                                        <Form.Control
                                          // required
                                          disabled
                                          size="sm"
                                          type="text"
                                          name="emergency_name1"
                                          id="emergency_name1"
                                          placeholder={`${t("emergency_name_1")}`}
                                          //   value={data.emergency_name1}
                                          //   onChange={(e) => handleChanges(e)}
                                        />
                                      </Form.Group>

                                      <Form.Group className="form-group col-xs-12 col-sm-12 col-md-4 col-lg-4">
                                        <Form.Label>
                                          {t("emergency_relationship_1")}
                                        </Form.Label>

                                        <Form.Control
                                          // required
                                          disabled
                                          size="sm"
                                          type="text"
                                          name="emergency_relationship1"
                                          id="emergency_relationship1"
                                          placeholder={`${t("emergency_relationship_1")}`}
                                          //   value={data.emergency_relationship1}
                                          //   onChange={(e) => handleChanges(e)}
                                        />
                                      </Form.Group>

                                      <Form.Group className="form-group col-xs-12 col-sm-12 col-md-4 col-lg-4">
                                        <Form.Label>
                                          {t("emergency_phone_1")}
                                        </Form.Label>

                                        <Form.Control
                                          // required
                                          size="sm"
                                          type="text"
                                          disabled
                                          name="emergency_phone1"
                                          id="emergency_phone1"
                                          placeholder={`${t("emergency_phone_1")}`}
                                          //   value={data.emergency_phone1}
                                          //   onChange={(e) => handleChanges(e)}
                                        />
                                      </Form.Group>

                                      <Form.Group className="form-group col-xs-12 col-sm-12 col-md-4 col-lg-">
                                        <Form.Label>
                                          {t("emergency_name_2")}
                                        </Form.Label>

                                        <Form.Control
                                          // required
                                          size="sm"
                                          type="text"
                                          disabled
                                          name="emergency_name2"
                                          id="emergency_name2"
                                          placeholder={`${t("emergency_name_2")}`}
                                          //   value={data.emergency_name2}
                                          //   onChange={(e) => handleChanges(e)}
                                        />
                                      </Form.Group>

                                      <Form.Group className="form-group col-xs-12 col-sm-12 col-md-4 col-lg-4">
                                        <Form.Label>
                                          {t("emergency_relationship_2")}
                                        </Form.Label>
                                        <Form.Control
                                          // required
                                          size="sm"
                                          disabled
                                          type="text"
                                          name="emergency_relationship2"
                                          id="emergency_relationship2"
                                          placeholder={`${t("emergency_relationship_2")}`}
                                          //   value={data.emergency_relationship2}
                                          //   onChange={(e) => handleChanges(e)}
                                        />
                                        <Form.Control.Feedback type="invalid">
                                          Relationship is required!
                                        </Form.Control.Feedback>
                                      </Form.Group>

                                      <Form.Group className="form-group col-xs-12 col-sm-12 col-md-4 col-lg-4">
                                        <Form.Label>
                                          {t("emergency_phone_2")}
                                        </Form.Label>

                                        <Form.Control
                                          // required
                                          disabled
                                          size="sm"
                                          type="text"
                                          name="emergency_phone2"
                                          id="emergency_phone2"
                                          placeholder={`${t("emergency_phone_2")}`}
                                          //   value={data.emergency_phone2}
                                          //   onChange={(e) => handleChanges(e)}
                                        />
                                        <Form.Control.Feedback type="invalid">
                                          Phone is required!
                                        </Form.Control.Feedback>
                                      </Form.Group>
                                    </div>

                                    <div className="row mt-3 locationFields rr-section-card">
                                      <div className="form-group col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                        <h4 className="rr-section-title">{t("hear_us")}</h4>
                                      </div>
                                      <div className="d-flex flex-wrap hear-options rr-checkbox-grid">
                                        <label className="form-check-label ml-sm-2">
                                          <input
                                            type="checkbox"
                                            className="form-check-input ageLabel"
                                            name="Website"
                                            value="Website"
                                            disabled
                                          />
                                          {t("website")}
                                          <i className="input-helper"></i>
                                        </label>

                                        <label className="form-check-label ml-sm-2">
                                          <input
                                            type="checkbox"
                                            className="form-check-input ageLabel"
                                            name="Church Bulletin"
                                            value="Church Bulletin"
                                            disabled
                                          />
                                          {t("church_bulletin")}
                                          <i className="input-helper"></i>
                                        </label>

                                        <label className="form-check-label ml-sm-2">
                                          <input
                                            type="checkbox"
                                            className="form-check-input ageLabel"
                                            name="Facebook"
                                            value="Facebook"
                                            disabled
                                          />
                                          {t("facebook")}
                                          <i className="input-helper"></i>
                                        </label>

                                        <label className="form-check-label ml-sm-2">
                                          <input
                                            type="checkbox"
                                            className="form-check-input ageLabel"
                                            name="School Marquee"
                                            value="School Marquee"
                                            disabled
                                          />
                                          {t("school_marquee")}
                                          <i className="input-helper"></i>
                                        </label>

                                        <label className="form-check-label ml-sm-2">
                                          <input
                                            type="checkbox"
                                            className="form-check-input ageLabel"
                                            name="Pulpit Talk/Table in Church"
                                            value="Pulpit Talk/Table in Church"
                                            disabled
                                          />
                                          {t("Pulpit_church")}
                                          <i className="input-helper"></i>
                                        </label>
                                      </div>
                                    </div>

                                    <Col
                                      lg={12}
                                      md={12}
                                      xs={12}
                                      sm={12}
                                      className="mt-5 locationFields rr-section-card"
                                    >
                                      <h4>
                                        {" "}
                                        <h4> {t("referral")}</h4>
                                      </h4>
                                      <Form.Group className="form-group mt-3">
                                        <Form.Control
                                          // required
                                          size="sm"
                                          type="text"
                                          disabled
                                          name="referral_from_a_friend_or_family_member"
                                          placeholder={`${t("referral")}`}
                                          id="referral_from_a_friend_or_family_member"
                                          //   value={data.referral_from_a_friend_or_family_member}
                                          className="form-control"
                                          //   onChange={(e) => {
                                          //     handleChanges(e);
                                          //   }}
                                        />
                                      </Form.Group>
                                    </Col>
                                    <Col
                                      lg={12}
                                      md={12}
                                      xs={12}
                                      sm={12}
                                      className="mt-5 locationFields"
                                    >
                                      <div className="rr-release-card">
                                        <h4 className="rr-release-title">
                                          {t("release_statement_title")}{" "}
                                          <span className="text-danger">*</span>
                                        </h4>
                                        <p className="rr-release-text">
                                          {t("release_statement")}
                                        </p>
                                        <div className="rr-acknowledgment-grid">
                                          <div>
                                            <label className="form-check-label ml-sm-2 hear_us rr-checkbox-item">
                                              <input
                                                type="checkbox"
                                                className="form-check-input ageLabel acknowledgmentCheck"
                                                name="husband_acknowledgment"
                                                value="husband_acknowledgment"
                                                disabled
                                              />
                                              {t("husband_acknowledgment")}
                                              <i className="input-helper"></i>
                                            </label>
                                          </div>
                                          <div className="wife_acknowledgement">
                                            <label className="form-check-label ml-sm-2 hear_us rr-checkbox-item">
                                              <input
                                                type="checkbox"
                                                className="form-check-input ageLabel acknowledgmentCheck"
                                                name="wife_acknowledgment"
                                                value="wife_acknowledgment"
                                                disabled
                                              />
                                              {t("wife_acknowledgment")}
                                              <i className="input-helper"></i>
                                            </label>
                                          </div>
                                        </div>
                                      </div>
                                    </Col>
                                    <Col
                                      lg={12}
                                      md={12}
                                      xs={12}
                                      className="text-center mb-5 mt-5"
                                    >
                                      <Button
                                        variant="primary"
                                        type="submit"
                                        className="rr-btn-submit"
                                        disabled
                                      >
                                        <i className="mdi mdi-heart"></i>
                                        <span>{t("register")}</span>
                                      </Button>
                                    </Col>
                                  </Form>
                                </div>
                              </div>
                            </div>
                          </div>
                          </div>
                        </Col>
                      </Row>
                    </Container>
                  </Form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
        {show ? (
          <DeleteModel
            show={show}
            handleClose={handleClose}
            DeleteData={deleteSchedule}
          ></DeleteModel>
        ) : null}
        {showDeleteModal ? (
          <DeleteModel
            show={showDeleteModal}
            content={
              <>
                <h5 className="mt-4 fw-bold">Retreat Team</h5>
                <div className="p-3 border rounded-3 bg-light shadow-sm">
                  {/* His Details */}
                  {editIndex && (
                    <>
                      <div className="mb-2">
                        <span className="fw-bold">Role:</span>{" "}
                        {editIndex && (
                          <span className="text-muted"> {editIndex.role}</span>
                        )}
                      </div>
                      <div className="mb-2">
                        <span className="fw-bold">Couple:</span>{" "}
                        {`${
                          editIndex && editIndex.hisFirstName
                            ? editIndex.hisFirstName
                            : ""
                        }` +
                          `${
                            editIndex && editIndex.herFirstName ? " & " : ""
                          }` +
                          `${
                            editIndex && editIndex.herFirstName
                              ? editIndex.herFirstName
                              : ""
                          }` +
                          " " +
                          `${
                            editIndex && editIndex.hisLastName
                              ? editIndex.hisLastName
                              : ""
                          }`}
                      </div>
                      <div className="mb-2">
                        <span className="fw-bold">Image:</span>{" "}
                        {editIndex && (
                          <img
                            src={editIndex.imageUrl}
                            style={{ height: "200px" }}
                            alt=""
                            srcset=""
                          />
                        )}
                      </div>
                    </>
                  )}
                </div>
              </>
            }
            handleClose={closeModel}
            DeleteData={removeCoupleImage}
          ></DeleteModel>
        ) : null}

        {removeCoupleModal ? (
          <DeleteModel
            show={removeCoupleModal}
            content={
              <>
                <h5 className="mt-4 fw-bold">Retreat Team</h5>
                <div className="p-3 border rounded-3 bg-light shadow-sm">
                  {/* His Details */}
                  {editIndex && (
                    <>
                      <div className="mb-2">
                        <span className="fw-bold">Role:</span>{" "}
                        {editIndex && (
                          <span className="text-muted"> {editIndex.role}</span>
                        )}
                      </div>
                      <div className="mb-2">
                        <span className="fw-bold">Couple:</span>{" "}
                        {`${
                          editIndex && editIndex.hisFirstName
                            ? editIndex.hisFirstName
                            : ""
                        }` +
                          `${
                            editIndex && editIndex.herFirstName ? " & " : ""
                          }` +
                          `${
                            editIndex && editIndex.herFirstName
                              ? editIndex.herFirstName
                              : ""
                          }` +
                          " " +
                          `${
                            editIndex && editIndex.hisLastName
                              ? editIndex.hisLastName
                              : ""
                          }`}
                      </div>
                    </>
                  )}
                </div>
              </>
            }
            handleClose={handleRemoveClose}
            DeleteData={removeCoupleFromRetreat}
          ></DeleteModel>
        ) : null}

        {removeAccessModal ? (
          <DeleteModel
            show={removeAccessModal}
            content={
              <>
                <h5 className="mt-4 fw-bold">Retreat Sub-Admin Detail</h5>
                <div className="p-3 border rounded-3 bg-light shadow-sm">
                  {/* His Details */}
                  {editIndex && (
                    <div className="mb-2">
                      <span className="fw-bold">Retreat Sub-Admin:</span>{" "}
                      {editIndex && (
                        <span className="text-muted"> {editIndex}</span>
                      )}
                    </div>
                  )}
                </div>
              </>
            }
            handleClose={handleAccessRmvClose}
            DeleteData={removeAccessFromRetreat}
          ></DeleteModel>
        ) : null}

        {mailMsgView ? (
          <ViewMailMsg
            show={mailMsgView}
            alertHeader={"Preview Email"}
            alertMessage={emailMsg}
            handleClose={() => {
              setMailMsgView(false);
            }}
            language={data.language}
          ></ViewMailMsg>
        ) : null}

        {createRetAdmin ? (
          <CreateRetreatSubAdmin
            show={createRetAdmin}
            alertHeader={"Mail Message"}
            alerMessage={"111111111111111111111"}
            allCoupleMails={allCoupleMails}
            ediUserIdClicked={ediUserIdClicked}
            data={data}
            handlerAccessRmvShow={handlerAccessRmvShow}
            editRetreat={editRetreat}
            getAllCouples={getAllCouples}
            handleClose={() => {
              setCreateRetAdmin(false);
            }}
          ></CreateRetreatSubAdmin>
        ) : null}

        {createRetTeam ? (
          <CreateRetreatTeam
            show={createRetTeam}
            allCoupleData={allCoupleData}
            priestsList={priestsList}
            coupleSelectForRole={coupleSelectForRole}
            rolesDataList={rolesDataList}
            roleSelect={roleSelect}
            roles={roles}
            ediUserIdClicked={ediUserIdClicked}
            setEditIndex={setEditIndex}
            editIndex={editIndex}
            handleClose={() => {
              setCreateRetTeam(false);
              editRetreat(ediUserIdClicked || data?.id);
            }}
            getRolesOfRetreats={getRolesOfRetreats}
            onTeamChange={refreshRetreatAdmins}
            onPeopleRefresh={() => {
              getAllCouples();
              getPriestsList();
            }}
          ></CreateRetreatTeam>
        ) : null}

        <AlertDelete
          show={coupleForRoleToRemove}
          alertHeader="Cannot Remove Retreat Administrator"
          alerMessage={
            <div className="">
              You have to first unselect this couple from Retreat Team Role.
            </div>
          }
          handleClose={() => setCoupleForRoleToRemove(false)}
          buttonText={"Close"}
        />

        {mailSample ? (
          <AlertDelete
            show={mailSample}
            alertHeader="Sample Email Message"
            alerMessage={
              <div>
                {dynamicEmailMsg ? (
                  <div dangerouslySetInnerHTML={{ __html: dynamicEmailMsg }} />
                ) : data.language === "spanish" ? (
                  <div style={{ textAlign: "center" }}>
                    <p>
                      Gracias por inscribirse en el retiro matrimonial
                      LOVESTRONG de San Pedro y San Pablo, programado del 18 al
                      20 de octubre de 2024. ¡Nos entusiasma que nos acompañen!
                    </p>
                    <p>Si tienes alguna pregunta, contáctanos aquí...</p>
                    <p>
                      <strong>Correo electrónico: </strong>
                      <a
                        href="mailto:solizspp.lovestrong@gmail.com"
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{ color: "#1155CC" }}
                      >
                        solizspp.lovestrong@gmail.com
                      </a>
                    </p>
                    <p style={{ color: "rgb(34, 34, 34)" }}>
                      <strong>Jen Soliz</strong>
                      <br />
                      210-288-1908
                    </p>
                    <p style={{ color: "#222222" }}>
                      <strong>Phil Soliz</strong>
                      <br />
                      210-779-3096
                    </p>
                    <p style={{ fontSize: "12px" }}>
                      Por favor, espere saber de nosotras pronto!
                    </p>
                    <p style={{ fontSize: "12px" }}>
                      <strong>¡VIVE! ¡AMA! ¡FUERTE!</strong>
                    </p>
                  </div>
                ) : (
                  <div style={{ textAlign: "center" }}>
                    <p>
                      Thank you for registering for the Sts. Peter and Paul
                      LOVESTRONG Marriage retreat scheduled for October 18-20,
                      2024. We are excited that you will join us!
                    </p>
                    <p>
                      If you have any questions, please reach out to us here...
                    </p>
                    <p>
                      <strong>Email: </strong>
                      <a
                        href="mailto:solizspp.lovestrong@gmail.com"
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{ color: "#1155CC" }}
                      >
                        solizspp.lovestrong@gmail.com
                      </a>
                    </p>
                    <p style={{ color: "rgb(34, 34, 34)" }}>
                      <strong>Jen Soliz</strong>
                      <br />
                      210-288-1908
                    </p>
                    <p style={{ color: "#222222" }}>
                      <strong>Phil Soliz</strong>
                      <br />
                      210-779-3096
                    </p>
                    <p style={{ fontSize: "12px" }}>
                      Please expect to hear from us soon!
                    </p>
                    <p style={{ fontSize: "12px" }}>
                      <strong>LIVE! LOVE! STRONG!</strong>
                    </p>
                  </div>
                )}
              </div>
            }
            handleClose={closeModel}
            buttonText={"Close"}
          />
        ) : null}

        {descriptionSample ? (
          <AlertDelete
            show={descriptionSample}
            alertHeader={t("description_sample")}
            alerMessage={
              <div>
                <DescriptionSampleTip />
                {dynamicDescription ? (
                  <div dangerouslySetInnerHTML={{ __html: dynamicDescription }} />
                ) : data.language === "spanish" ? (
                  <div style={{ textAlign: "center" }}>
                    <p style={{ color: "rgb(53, 53, 53)", fontSize: "16px" }}>
                      El costo es de $175 por pareja. Se requiere un depósito de
                      $75 al momento de enviar el formulario de inscripción. El
                      número de parejas que podemos acomodar es limitado y la
                      disponibilidad es por orden de llegada. El costo de
                      inscripción cubre la cena del viernes, tres comidas el
                      sábado y el desayuno y almuerzo del domingo. También cubre
                      todos los materiales del retiro. No se proporciona cuidado
                      de niños.
                    </p>

                    <p>
                      <strong>
                        <em>
                          Todas las parejas del retiro deben comprometerse a
                          asistir a todas las actividades del fin de semana de 3
                          días.
                        </em>
                      </strong>
                    </p>

                    <p style={{ fontSize: "20px", color: "rgb(34, 34, 34)" }}>
                      Iglesia de San Pedro y San Pablo
                      <br />
                      386 N Castell Ave.,
                      <br />
                      New Braunfels, TX, 78130
                    </p>

                    <p>Para preguntas, aquí está la información de contacto:</p>

                    <p>
                      <a
                        href="mailto:solizspp.lovestrong@gmail.com"
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{ color: "#1155CC" }}
                      >
                        solizspp.lovestrong@gmail.com
                      </a>
                    </p>

                    <p style={{ color: "#222222" }}>
                      Phil (210-779-3096)
                      <br />
                      Jen (210-288-1908)
                    </p>

                    <p>¡Gracias!</p>
                  </div>
                ) : (
                  <div style={{ textAlign: "center" }}>
                    <p style={{ color: "rgb(53, 53, 53)", fontSize: "16px" }}>
                      The cost is $175 per couple. A $75 deposit is due with the
                      registration form. We are limited as to the number of
                      couples we can accommodate, and availability is on a first
                      come, first-serve basis. The registration cost covers
                      dinner on Friday, three meals on Saturday, and breakfast
                      and lunch on Sunday. It will also cover all retreat
                      materials. Childcare is not provided.
                    </p>

                    <p>
                      <strong>
                        <em>
                          All Retreat Couples must commit to attending the
                          entire 3-day weekend’s activities.
                        </em>
                      </strong>
                    </p>
                    <p style={{ fontSize: "20px", color: "rgb(34, 34, 34)" }}>
                      Sts. Peter and Paul Church
                      <br />
                      386 N Castell Ave.,
                      <br />
                      New Braunfels, TX, 78130
                    </p>

                    <p>For questions, here is the contact info:</p>

                    <p>
                      <a
                        href="mailto:solizspp.lovestrong@gmail.com"
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{ color: "#1155CC" }}
                      >
                        solizspp.lovestrong@gmail.com
                      </a>
                    </p>

                    <p style={{ color: "#222222" }}>
                      Phil (210-779-3096)
                      <br />
                      Jen (210-288-1908)
                    </p>

                    <p>Thank you!</p>
                  </div>
                )}
              </div>
            }
            handleClose={closeModel}
            buttonText={t("close")}
          />
        ) : null}

        {isDisabledShow ? (
          <AlertModal
            show={isDisabledShow}
            handleClose={closeIsDisabledPopUp}
            message={`Are you sure you want to ${
              editIndex?.mail?.isDisabled === false ? "DISABLE" : "ENABLE"
            } this Admin?`}
            actionFunction={retreatDisabledSubAdmin}
            cancel={"Cancel"}
            okay={"Okay"}
            heading={"ALERT!!"}
          />
        ) : null}
      </div>
    </>
  );
};
